var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharepointIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.829,
    height: 25.334,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stx0{fill:#036C70;}\n\t.stx1{fill:#1A9BA1;}\n\t.stx2{fill:#37C6D0;}\n\t.stx3{fill:#03686C;}\n\t.stx4{fill:#19969B;}\n\t.stx5{fill:#35BFC9;}\n\t.stx6{fill:#F6F6F6;}\n\t.stx7{fill:#EEEEEE;}\n\t.stx8{fill:#33B9C2;}\n\t.stx9{fill:#036165;}\n\t.stx10{fill:#178C91;}\n\t.stx11{fill:#32B3BC;}\n\t.stx12{fill:#30ACB5;}\n\t.stx13{fill:#035B5E;}\n\t.stx14{fill:#168388;}\n\t.stx15{fill:#2EA7AF;}\n\t.stx16{fill:#036B6F;}\n\t.stx17{fill:#03676B;}\n\t.stx18{fill:#036164;}\n\t.stx19{fill:#FDFDFD;}\n\t.stx20{fill:#036468;}\n\t.stx21{fill:#035A5E;}\n\t.stx22{fill:#DDDDDD;}\n\t.stx23{fill:#D6D6D6;}\n\t.stx24{fill:#CFCFCF;}\n\t.stx25{fill:#2DA1A9;}\n\t.stx26{fill:#C1C1C1;}\n\t.stx27{fill:#B6B6B6;}\n\t.stx28{fill:#278E95;}\n\t.stx29{fill:#035658;}\n\t.stx30{fill:#147B7F;}\n\t.stx31{fill:#2B9DA4;}\n\t.stx32{fill:#035558;}\n\t.stx33{fill:#024649;}\n\t.stx34{fill:#024648;}\n\t.stx35{fill:#CBCBCB;}\n\t.stx36{fill:#CACACA;}\n\t.stx37{fill:#025659;}\n\t.stx38{fill:#025054;}\n\t.stx39{fill:#024C4F;}\n\t.stx40{fill:#013537;}\n\t.stx41{fill:#023A3C;}\n\t.stx42{fill:#013335;}\n\t.stx43{fill:#024346;}\n\t.stx44{fill:#013032;}\n\t.stx45{fill:#012F30;}\n\t.stx46{fill:#012C2E;}\n\t.stx47{fill:#024042;}\n\t.stx48{fill:#023F41;}\n\t.stx49{fill:#023739;}\n\t.stx50{fill:#013133;}\n\t.stx51{fill:#012D2F;}\n\t.stx52{fill:#2DA2AA;}\n\t.stx53{fill:#2A979F;}\n\t.stx54{fill:#C9C9C9;}\n\t.stx55{fill:#ACACAC;}\n\t.stx56{fill:#25868D;}\n\t.stx57{fill:#C2C2C2;}\n\t.stx58{fill:#BDBDBD;}\n\t.stx59{fill:#A8A8A8;}\n\t.stx60{fill:#A3A3A3;}\n\t.stx61{fill:#237F85;}\n\t.stx62{fill:#9F9F9F;}\n\t.stx63{fill:#9B9B9B;}\n\t.stx64{fill:#21797E;}\n\t.stx65{fill:#8E8E8E;}\n\t.stx66{fill:#888888;}\n\t.stx67{fill:#7D7D7D;}\n\t.stx68{fill:#797979;}\n\t.stx69{fill:#1E6C71;}\n\t.stx70{fill:#1D686D;}\n\t.stx71{fill:#21787E;}\n\t.stx72{fill:#207378;}\n\t.stx73{fill:#1E6D73;}\n\t.stx74{fill:#1C6368;}\n\t.stx75{fill:#1B6065;}\n\t.stx76{fill:#035053;}\n\t.stx77{fill:#137377;}\n\t.stx78{fill:#29939A;}\n\t.stx79{fill:#288F96;}\n\t.stx80{fill:#278B92;}\n\t.stx81{fill:#237F86;}\n\t.stx82{fill:#237C83;}\n\t.stx83{fill:#207379;}\n\t.stx84{fill:#1F7177;}\n\t.stx85{fill:#989898;}\n\t.stx86{fill:#949494;}\n\t.stx87{fill:#919191;}\n\t.stx88{fill:#838383;}\n\t.stx89{fill:#7E7E7E;}\n\t.stx90{fill:#1B6267;}\n\t.stx91{fill:#757575;}\n\t.stx92{fill:#717171;}\n\t.stx93{fill:#18585D;}\n\t.stx94{fill:#1C6369;}\n\t.stx95{fill:#175256;}\n\t.stx96{fill:#237D83;}\n\t.stx97{fill:#1D696E;}\n\t.stx98{fill:#1D676C;}\n\t.stx99{fill:#1E6A70;}\n\t.stx100{fill:#1A5D62;}\n\t.stx101{fill:#1A5C60;}\n\t.stx102{fill:#248389;}\n\t.stx103{fill:#175458;}\n\t.stx104{fill:#195C60;}\n\t.stx105{fill:#164E52;}\n\t.stx106{fill:#1F7176;}\n\t.stx107{fill:#18565B;}\n\t.stx108{fill:#165054;}\n\t.stx109{fill:#154B4F;}\n\t.stx110{fill:#024345;}\n\t.stx111{fill:#106064;}\n\t.stx112{fill:#227B81;}\n\t.stx113{fill:#707070;}\n\t.stx114{fill:#6E6E6E;}\n\t.stx115{fill:#6B6B6B;}\n\t.stx116{fill:#696969;}\n\t.stx117{fill:#023D3F;}\n\t.stx118{fill:#0F575A;}\n\t.stx119{fill:#1F6F75;}\n\t.stx120{fill:#0E5356;}\n\t.stx121{fill:#0C4A4C;}\n\t.stx122{fill:#1A5E63;}\n\t.stx123{fill:#012F31;}\n\t.stx124{fill:#144A4D;}\n\t.stx125{fill:#0C4548;}\n\t.stx126{fill:#19595D;}\n\t.stx127{fill:#175357;}\n\t.stx128{fill:#012C2D;}\n\t.stx129{fill:#012A2D;}\n\t.stx130{fill:#0A3D3F;}\n\t.stx131{fill:#012A2C;}\n\t.stx132{fill:#01292B;}\n\t.stx133{fill:#01282A;}\n\t.stx134{fill:#0A3A3D;}\n\t.stx135{fill:#012829;}\n\t.stx136{fill:#012729;}\n\t.stx137{fill:#09393B;}\n\t.stx138{fill:#14494C;}\n\t.stx139{fill:#14484C;}\n\t.stx140{fill:#ECECEC;}\n\t.stx141{fill:#DEDEDE;}\n\t.stx142{fill:#D7D7D7;}\n\t.stx143{fill:#B2B2B2;}\n\t.stx144{fill:#036569;}\n\t.stx145{fill:#E6E6E6;}\n\t.stx146{fill:#025558;}\n\t.stx147{fill:#025457;}\n\t.stx148{fill:#024F51;}\n\t.stx149{fill:#BFBFBF;}\n\t.stx150{fill:#025154;}\n\t.stx151{fill:#AAAAAA;}\n\t.stx152{fill:#02484B;}\n\t.stx153{fill:#BEBEBE;}\n\t.stx154{fill:#025053;}\n\t.stx155{fill:#024144;}\n\t.stx156{fill:#023E40;}\n\t.stx157{fill:#023B3D;}\n\t.stx158{fill:#02393B;}\n\t.stx159{fill:#012E30;}\n\t.stx160{fill:#012B2C;}\n\t.stx161{fill:#024043;}\n\t.stx162{fill:#02373A;}\n\t.stx163{fill:#023839;}\n\t.stx164{fill:#969696;}\n\t.stx165{fill:#D0D0D0;}\n\t.stx166{fill:#8F8F8F;}\n\t.stx167{fill:#8A8A8A;}\n\t.stx168{fill:#7A7A7A;}\n\t.stx169{fill:#6F6F6F;}\n\t.stx170{fill:#858585;}\n\t.stx171{fill:#6D6D6D;}\n\t.stx172{fill:#03575A;}\n\t.stx173{fill:#035255;}\n\t.stx174{fill:#034E50;}\n\t.stx175{fill:#024143;}\n\t.stx176{fill:#B9B9B9;}\n\t.stx177{fill:#024A4D;}\n\t.stx178{fill:#023638;}\n\t.stx179{fill:#013234;}\n\t.stx180{fill:#013334;}\n\t.stx181{fill:#012A2B;}\n\t.stx182{fill:#013436;}\n\t.stx183{fill:#6C6C6C;}\n\t.stx184{fill:#6A6A6A;}\n\t.stx185{fill:#676767;}\n\t.stx186{fill:#656565;}\n\t.stx187{fill:#154C4F;}\n\t.stx188{fill:#14474B;}\n\t.stx189{fill:#012728;}\n\t.stx190{fill:#09373A;}\n\t.stx191{fill:#035B5F;}\n\t.stx192{fill:#03585B;}\n\t.stx193{fill:#02383A;}\n\t.stx194{fill:#03494C;}\n\t.stx195{fill:#AFAFAF;}\n\t.stx196{fill:#024A4C;}\n\t.stx197{fill:#024446;}\n\t.stx198{fill:#AEAEAE;}\n\t.stx199{fill:#024245;}\n\t.stx200{fill:#013536;}\n\t.stx201{fill:#808080;}\n\t.stx202{fill:#012B2D;}\n\t.stx203{fill:#013638;}\n\t.stx204{fill:#012E2F;}\n\t.stx205{fill:#8C8C8C;}\n\t.stx206{fill:#023C3D;}\n\t.stx207{fill:#0E5559;}\n\t.stx208{fill:#0D4C4E;}\n\t.stx209{fill:#878787;}\n\t.stx210{fill:#686868;}\n\t.stx211{fill:#0B3F42;}\n\t.stx212{fill:#0A3D40;}\n\t.stx213{fill:#0A3C3E;}\n\t.stx214{fill:#0B3B3D;}\n\t.stx215{fill:#747474;}\n\t.stx216{fill:#828282;}\n\t.stx217{fill:#7C7C7C;}\n\t.stx218{fill:#646464;}\n\t.stx219{fill:#626262;}\n\t.stx220{fill:#0B4446;}\n\t.stx221{fill:#0B4245;}\n\t.stx222{fill:#0A393B;}\n\t.stx223{fill:#093739;}\n\t.stx224{fill:#616161;}\n\t.stx225{fill:#01292A;}\n\t.stx226{fill:#5F5F5F;}\n\t.stx227{fill:#5E5E5E;}\n\t.stx228{fill:#14494D;}\n\t.stx229{fill:#14474A;}\n\t.stx230{fill:#03787C;}\n\t.stx231{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stx0",
    d: "M237.4,49c65.9,0,119.4,53.4,119.4,119.4c0,65.9-53.4,119.4-119.4,119.4c-65.9,0-119.4-53.4-119.4-119.4 C118,102.4,171.5,49,237.4,49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx1",
    d: "M348.9,171.4c56.4,0,102.2,45.7,102.2,102.2c0,56.4-45.7,102.2-102.2,102.2c-56.4,0-102.2-45.7-102.2-102.2 C246.8,217.1,292.5,171.4,348.9,171.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx2",
    d: "M249.9,287.7c45.1,0,81.7,36.6,81.7,81.7c0,45.1-36.6,81.7-81.7,81.7c-45.1,0-81.7-36.6-81.7-81.7 C168.3,324.3,204.8,287.7,249.9,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx3",
    d: "M256.4,145.9h-9.3c0.8,1.2,1.4,2.5,1.7,3.9h2.4l0,0h0.1h-0.1c6.9,0.1,12.5,5.8,12.3,12.7v54.8 c1.4-2.2,3-4.3,4.6-6.4v-52.5C268.3,151.8,263,146.2,256.4,145.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx4",
    d: "M268.2,211c-1.6,2.1-3.1,4.2-4.6,6.4v71.5c1.5,0.3,3.1,0.6,4.6,0.9V211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx5",
    d: "M263.6,288.9v56.7v0.1c0,0.8-0.1,1.5-0.2,2.3c2.9-5.4,4.8-13.7,4.8-22.5v-35.7 C266.7,289.4,265.1,289.1,263.6,288.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx6",
    d: "M176.4,332.7l-0.1,0c-3.3,6.7-5.8,13.9-7.2,21.6h0.1C170.6,346.7,173,339.4,176.4,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx7",
    d: "M168.5,374.7h-0.1c0.1,1.8,0.2,3.6,0.6,5.4C168.7,378.3,168.6,376.5,168.5,374.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx8",
    d: "M250.7,364.5c-0.9,0.5-1.9,0.9-2.9,1.2c-2.7,5.4-8.3,9-14.7,9c-0.2,0-0.4,0-0.6,0h-63.9 c0.1,1.8,0.3,3.6,0.5,5.4c0,0.2,0.1,0.3,0.1,0.5h64.1c0.3,0,0.6,0,0.8,0c8.8,0,16.1-6.9,16.6-15.8 C250.6,364.7,250.7,364.6,250.7,364.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx8",
    d: "M263.4,347.9c-0.1,0.1-0.1,0.3-0.2,0.4v0.4c0,0,0,0.1,0,0.1C263.3,348.5,263.3,348.2,263.4,347.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx9",
    d: "M251.3,149.8h-2.4c0.3,1,0.4,2,0.4,3.1v2.1h1.4h0.1c6.9,0.1,12.4,5.7,12.4,12.6V218c0.1-0.2,0.3-0.4,0.4-0.6 v-54.8C263.7,155.6,258.2,149.9,251.3,149.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx10",
    d: "M263.6,217.4c-0.1,0.2-0.3,0.4-0.4,0.6v70.8c0.1,0,0.3,0,0.4,0.1V217.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx11",
    d: "M263.2,288.8v59.5c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.7,0.2-1.5,0.2-2.3v-0.1v-56.7 C263.5,288.8,263.3,288.8,263.2,288.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx8",
    d: "M263.2,348.8c-0.9,3.5-3.4,6.4-6.6,8c-0.3,1.3-0.9,2.5-1.6,3.6C259.7,358.7,263.1,354.2,263.2,348.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx12",
    d: "M263.2,348.3c-1.8,3.2-3.9,5.3-6.2,5.9c0,0.9-0.2,1.8-0.4,2.7c3.2-1.6,5.7-4.5,6.6-8c0,0,0-0.1,0-0.1V348.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx13",
    d: "M250.7,155L250.7,155h-1.5v5.8c6.7,0.2,12.1,5.8,12.1,12.5v47.6c0.6-1,1.2-2,1.8-2.9v-50.4 C263.2,160.7,257.6,155.1,250.7,155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx14",
    d: "M263.2,218c-0.6,1-1.2,1.9-1.8,2.9v67.6c0.6,0.1,1.2,0.2,1.8,0.3V218"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx15",
    d: "M261.4,288.5v36.6c-0.1,6.8-1.6,13.4-4.4,19.4v9.1c0,0.2,0,0.3,0,0.5c2.3-0.6,4.4-2.7,6.2-5.9v-59.5 C262.6,288.7,262,288.6,261.4,288.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx16",
    d: "M236.6,140.2H121.5c-0.3,1.2-0.6,2.4-0.8,3.6h115.1h0.1c2.6,0,5,0.8,7,2.1h4.2 C244.8,142.5,241,140.3,236.6,140.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx17",
    d: "M247.1,145.9h-4.2c1.5,1,2.8,2.3,3.7,3.9h2.2C248.5,148.4,247.9,147.1,247.1,145.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx18",
    d: "M248.8,149.8h-2.2c0.9,1.5,1.5,3.1,1.7,4.9c0,0.1,0.1,0.2,0.1,0.3h0.8v-2.1 C249.2,151.8,249.1,150.8,248.8,149.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx19",
    d: "M228.2,287.4c3,0.2,6,0.3,9.1,0.3c0.1,0,0.1,0,0.2,0c2,0,3.9,0,5.8-0.1c0.6,0,1.2-0.1,1.8-0.1 c0.4,0,0.7-0.1,1.1-0.1c-2.9,0.2-5.8,0.3-8.7,0.3c-2.8,0-5.6-0.1-8.4-0.3C228.7,287.4,228.5,287.4,228.2,287.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx16",
    d: "M247.1,287.2c-1.6,0.2-3.2,0.3-4.8,0.3c-1.6,0.1-3.2,0.1-4.8,0.1c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8,0-1.3,0 c-2.3,0-4.5-0.1-6.8-0.2c2.8,0.2,5.6,0.3,8.4,0.3c2.9,0,5.8-0.1,8.7-0.3C246.4,287.4,246.8,287.3,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx20",
    d: "M242.2,287.6c-1.5,0-2.9,0-4.4,0c-0.3,0-0.5,0-0.8,0c0.1,0,0.3,0,0.4,0C239,287.6,240.6,287.6,242.2,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx21",
    d: "M249.2,155h-0.8c0.5,1.4,0.8,2.9,0.8,4.5v1.3c0,0,0,0,0,0V155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx22",
    d: "M169.2,354.3h-0.1c-0.9,4.9-1.4,9.9-1.4,15v5.4h0.6c-0.1-1.4-0.1-2.8-0.1-4.3c0-0.4,0-0.7,0-1.1H168 c0-1.1,0-2.1,0.1-3.2H168c0.1-1.6,0.2-3.3,0.3-4.9h0c0.2-1.7,0.4-3.4,0.7-5.1C169,355.5,169.1,354.9,169.2,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx23",
    d: "M176.4,332.7L176.4,332.7c-3.4,6.7-5.8,14-7.3,21.6h0.1C170.6,346.7,173.1,339.4,176.4,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx24",
    d: "M168.3,369.3L168.3,369.3c0,0.4,0,0.7,0,1.1c0,1.4,0,2.9,0.1,4.3h0.1c-0.1-1.8-0.2-3.5-0.2-5.3 C168.3,369.3,168.3,369.3,168.3,369.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx25",
    d: "M247.7,365.7c-1,0.3-2.1,0.4-3.2,0.4h-1.7c-2.7,2-6.1,3.2-9.7,3.2c-0.1,0-0.1,0-0.2,0h-64.6c0,0,0,0.1,0,0.1 c0,1.8,0.1,3.5,0.2,5.3h63.9c0.2,0,0.4,0,0.6,0C239.4,374.7,245,371.1,247.7,365.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx26",
    d: "M168.3,366.1H168c0,1-0.1,2.1-0.1,3.2h0.3C168.3,368.2,168.3,367.2,168.3,366.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx27",
    d: "M168.4,366.1L168.4,366.1c-0.1,1-0.1,2.1-0.1,3.2h0C168.3,368.2,168.3,367.2,168.4,366.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx28",
    d: "M242.8,366.1h-74.5c0,1-0.1,2.1-0.1,3.2h64.6c0.1,0,0.1,0,0.2,0C236.8,369.3,240.1,368.1,242.8,366.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx24",
    d: "M168.9,356.1c-0.3,1.7-0.5,3.4-0.7,5.1h0C168.5,359.5,168.7,357.8,168.9,356.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx29",
    d: "M249.2,160.8v0.7c2.6,1.7,4.5,3.7,4.5,6v6.4c2,2.2,3.3,5.2,3.3,8.4V229c1.3-2.8,2.8-5.5,4.4-8.1v-47.6 C261.4,166.5,256,161,249.2,160.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx30",
    d: "M261.4,220.9c-1.6,2.6-3,5.3-4.4,8.1v59c1.5,0.1,2.9,0.3,4.4,0.5V220.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx31",
    d: "M257,288v56.6c2.8-6.1,4.3-12.7,4.4-19.4v-36.6C259.9,288.3,258.5,288.1,257,288"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx32",
    points: "249.2,160.8 249.2,161.5 249.2,161.5 249.2,160.8 249.2,160.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx33",
    d: "M249.2,161.5v2.7c2.3,2.3,3.8,5.5,3.8,9.1c0.2,0.2,0.5,0.5,0.7,0.7v-6.4C253.7,165.2,251.8,163.2,249.2,161.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx34",
    points: "249.2,161.5 249.2,164.2 249.2,164.2 249.2,161.5 249.2,161.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx35",
    d: "M118,169.2c0,57,41.3,107.3,99.4,116.9l0.1,0c3.6,0.6,7.2,1,10.8,1.3c-6.5-0.5-12.9-1.5-19.3-3.1 c-4.4-1.1-8.7-2.4-12.9-3.9c-41.7-15.2-71-52.5-76.9-95.6C118.4,179.7,118,174.5,118,169.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx36",
    d: "M196,280.4c4.2,1.5,8.5,2.9,12.9,3.9c6.3,1.6,12.8,2.6,19.3,3.1c0.3,0,0.5,0,0.8,0.1 c-9.2-0.6-18.1-2.3-26.5-4.9c-0.8-0.3-1.7-0.5-2.5-0.8C198.6,281.3,197.3,280.8,196,280.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx37",
    d: "M247.1,287.2L247.1,287.2c-1.3,0.2-2.6,0.3-4,0.3c-0.3,0-0.6,0-0.9,0C243.9,287.5,245.5,287.4,247.1,287.2 L247.1,287.2 M202.4,282.5c8.5,2.6,17.4,4.3,26.5,4.9c2.3,0.1,4.5,0.2,6.8,0.2c0.4,0,0.8,0,1.3,0c-0.6,0-1.2,0-1.8,0 c-7.7-0.1-15.4-0.9-22.9-2.5C209,284.4,205.7,283.5,202.4,282.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx38",
    d: "M247,287.2h-0.1c-0.2,0-0.3,0-0.5,0.1c-1.1,0.1-2.2,0.2-3.3,0.3C244.4,287.5,245.8,287.4,247,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx38",
    d: "M243.1,287.5c-1.8,0.1-3.6,0.1-5.5,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3,0c0,0-0.1,0-0.1,0c0.6,0,1.2,0,1.8,0c0.3,0,0.5,0,0.8,0c1.5,0,3,0,4.4,0 C242.5,287.6,242.8,287.6,243.1,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx39",
    d: "M246.5,287.3c-2.9,0.3-5.9,0.3-8.9,0.3c0,0,0,0,0,0c0,0,0,0,0,0c1.9,0,3.7,0,5.5-0.1 C244.2,287.5,245.4,287.4,246.5,287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx40",
    d: "M246.9,287.2L246.9,287.2c-0.2,0-0.3,0-0.5,0.1C246.6,287.3,246.8,287.2,246.9,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx41",
    d: "M237.5,287.6L237.5,287.6c-0.2,0-0.3,0-0.3,0C237.3,287.6,237.4,287.6,237.5,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx40",
    d: "M237.5,287.6c0,0-0.1,0-0.1,0l0,0H237.5L237.5,287.6C237.5,287.6,237.5,287.6,237.5,287.6 C237.5,287.6,237.5,287.6,237.5,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx42",
    d: "M246.9,287.2L246.9,287.2c-2.9,0.4-5.9,0.4-9.1,0.4c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c3,0,6,0,8.9-0.3 C246.6,287.3,246.7,287.2,246.9,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx33",
    d: "M247.1,287.2C247.1,287.2,247,287.2,247.1,287.2L247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx43",
    d: "M247.1,287.2c-0.1,0-0.1,0-0.2,0L247.1,287.2C247,287.2,247.1,287.2,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx44",
    d: "M247.1,287.2c-0.1,0-0.1,0-0.2,0h0C247,287.2,247,287.2,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx45",
    d: "M247.1,287.2c-0.1,0-0.2,0-0.3,0h0.1C247,287.2,247,287.2,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx44",
    d: "M246.8,287.2L246.8,287.2c-2.9,0.4-6,0.4-9,0.4C240.9,287.6,244,287.6,246.8,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M247.1,287.2c-0.1,0-0.2,0-0.3,0h0C246.9,287.2,247,287.2,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx47",
    d: "M249.2,164.2v3.8c0.1,0.6,0.2,1.2,0.3,1.8c0.2,0.5,0.3,1,0.5,1.5c1.1,0.5,2.1,1.2,3,2.1 C253,169.7,251.6,166.5,249.2,164.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx48",
    d: "M249.2,164.2v3.7c0,0,0,0,0,0L249.2,164.2C249.2,164.2,249.2,164.2,249.2,164.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx49",
    d: "M249.2,168L249.2,168c0.1,0.6,0.2,1.2,0.3,1.7c0,0,0,0,0,0C249.5,169.1,249.4,168.5,249.2,168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx49",
    d: "M249.2,167.9L249.2,167.9C249.2,168,249.2,168,249.2,167.9L249.2,167.9C249.2,167.9,249.2,167.9,249.2,167.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M249.2,168v1c0.1,0.2,0.2,0.5,0.3,0.7C249.5,169.1,249.4,168.5,249.2,168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M249.2,167.9v1c0,0,0,0,0,0L249.2,167.9C249.2,168,249.2,168,249.2,167.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx49",
    d: "M249.5,169.7c0,0.4,0.1,0.8,0.1,1.3c0.1,0.1,0.3,0.1,0.4,0.2C249.9,170.7,249.7,170.2,249.5,169.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M249.5,169.7c0,0.4,0.1,0.9,0.1,1.3c0,0,0,0,0,0C249.6,170.6,249.6,170.1,249.5,169.7 C249.5,169.7,249.5,169.7,249.5,169.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M249.2,169v1.8c0.1,0.1,0.3,0.1,0.4,0.2c0-0.4,0-0.9-0.1-1.3C249.4,169.5,249.3,169.2,249.2,169"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M249.2,169v1.8c0,0,0,0,0,0L249.2,169C249.2,169,249.2,169,249.2,169"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx8",
    d: "M255,360.5c-1.3,0.5-2.8,0.8-4.3,0.8v3.3c0,0,0,0,0,0C252.4,363.5,253.9,362.1,255,360.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx12",
    d: "M250.7,361.2C250.7,361.2,250.6,361.2,250.7,361.2l-1.4,0c-0.3,1.6-0.8,3.1-1.5,4.5c1-0.3,2-0.7,2.9-1.2 c0,0,0,0,0,0V361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx12",
    d: "M256.6,356.8c-1.6,0.8-3.5,1.2-5.4,1.2h-0.5v3.2c1.5,0,3-0.3,4.3-0.8C255.7,359.4,256.2,358.1,256.6,356.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx52",
    d: "M250.7,358.1h-1.1v0.7v0c0,0.8-0.1,1.6-0.3,2.4h1.4c0,0,0,0,0,0V358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx52",
    d: "M257,354.1c-0.4,0.1-0.8,0.2-1.2,0.2h-4.6c-0.2,0.2-0.3,0.4-0.5,0.6v3.2h0.5c1.9,0,3.8-0.4,5.4-1.2 C256.8,356,256.9,355.1,257,354.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx31",
    d: "M257,344.6c-1.6,3.4-3.5,6.7-5.9,9.7h4.6c0.4,0,0.8-0.1,1.2-0.2c0-0.2,0-0.3,0-0.5V344.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx53",
    d: "M250.7,354.9c-0.4,0.5-0.7,0.9-1.1,1.4v1.8h1.1V354.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx24",
    d: "M168.4,361.2L168.4,361.2c-0.2,1.6-0.3,3.2-0.4,4.9h0.1C168.1,364.5,168.2,362.8,168.4,361.2 M169.3,354.3 L169.3,354.3c-0.1,0.6-0.2,1.2-0.3,1.8C169,355.5,169.1,354.9,169.3,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M176.5,332.7L176.5,332.7c-3.4,6.7-5.9,14-7.2,21.6h0C170.7,346.6,173.1,339.4,176.5,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx53",
    d: "M249.3,361.2h-1.9c-1.1,1.9-2.7,3.6-4.5,4.9h1.7c1.1,0,2.2-0.1,3.2-0.4C248.4,364.3,249,362.8,249.3,361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx27",
    d: "M168.7,361.2h-0.3c-0.2,1.6-0.3,3.2-0.3,4.9h0.3C168.4,364.5,168.5,362.8,168.7,361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx55",
    d: "M168.7,361.2L168.7,361.2c-0.2,1.6-0.3,3.2-0.4,4.9h0C168.4,364.5,168.5,362.8,168.7,361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx56",
    d: "M247.3,361.2h-3.5c-2.8,2-6.2,3.3-9.9,3.3c-0.1,0-0.1,0-0.2,0h-64.6c0.1-1.1,0.1-2.2,0.3-3.3h-0.7 c-0.2,1.6-0.3,3.2-0.3,4.9h74.5C244.6,364.8,246.2,363.1,247.3,361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx57",
    d: "M169.4,354.3L169.4,354.3c-0.2,0.6-0.3,1.2-0.4,1.8c-0.3,1.7-0.5,3.4-0.6,5.1h0.1 C168.6,358.9,168.9,356.6,169.4,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx58",
    d: "M176.6,332.7l-0.1,0c-3.4,6.7-5.8,14-7.2,21.6h0.1C170.8,346.7,173.2,339.4,176.6,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx55",
    d: "M169.5,354.3h-0.2c-0.4,2.3-0.8,4.6-1,6.9h0.3c0.1-1.1,0.2-2.1,0.4-3.2h-0.1 C169.1,356.8,169.3,355.5,169.5,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx59",
    d: "M176.6,332.7L176.6,332.7c-3.4,6.7-5.9,14-7.3,21.6h0.2c0.1-0.6,0.2-1.2,0.3-1.7h-0.1 C171.2,345.5,173.5,338.9,176.6,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx60",
    d: "M169.1,358.1L169.1,358.1c-0.2,1-0.3,2.1-0.4,3.2h0C168.8,360.2,168.9,359.1,169.1,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx61",
    d: "M169.4,358.1h-0.3c-0.1,1-0.3,2.1-0.4,3.2h0.7c0-0.3,0.1-0.5,0.1-0.8h-0.3 C169.2,359.6,169.3,358.9,169.4,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx60",
    d: "M169.5,354.3L169.5,354.3c-0.3,1.3-0.5,2.5-0.6,3.8h0.1c0.1-0.4,0.1-0.8,0.2-1.1h-0.1 C169.2,356,169.4,355.2,169.5,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx62",
    d: "M169.9,352.6L169.9,352.6c-0.1,0.6-0.3,1.2-0.4,1.7h0C169.6,353.7,169.8,353.1,169.9,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx63",
    d: "M169.2,356.9L169.2,356.9c-0.1,0.4-0.1,0.8-0.2,1.1h0C169.1,357.7,169.2,357.3,169.2,356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx64",
    d: "M169.5,356.9h-0.3c-0.1,0.4-0.1,0.8-0.2,1.1h0.3C169.4,357.7,169.5,357.3,169.5,356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx28",
    d: "M249.5,358.1h-0.8c-0.4,1.1-0.9,2.2-1.5,3.2h1.9c0.1-0.8,0.2-1.6,0.3-2.4v0V358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx61",
    d: "M248.8,358.1h-1.7c-0.9,1.2-2,2.3-3.2,3.2h3.5C247.9,360.2,248.4,359.2,248.8,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx56",
    d: "M249.5,356.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.5-0.3,1-0.4,1.4h0.8V356.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx64",
    d: "M249.2,356.6c-0.1,0.1-0.2,0.2-0.3,0.3h-1.1c-0.3,0.4-0.5,0.8-0.8,1.1h1.7 C248.9,357.6,249.1,357.1,249.2,356.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx65",
    d: "M176.6,332.7L176.6,332.7c-3.1,6.2-5.5,12.9-6.9,19.9h0.1c0.1-0.3,0.1-0.6,0.2-0.9h-0.1 C171.4,344.9,173.7,338.6,176.6,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx66",
    d: "M170.1,351.6L170.1,351.6c-0.1,0.3-0.2,0.6-0.2,0.9h0C169.9,352.2,170,351.9,170.1,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx67",
    d: "M176.7,332.7L176.7,332.7c-3,5.9-5.3,12.3-6.7,19h0.1c0.4-1.9,0.9-3.7,1.4-5.5h-0.1 C172.7,341.4,174.5,336.9,176.7,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx68",
    d: "M171.5,346.1L171.5,346.1c-0.5,1.8-1,3.6-1.4,5.5h0C170.5,349.8,170.9,347.9,171.5,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx69",
    d: "M169.7,358.1h-0.3c-0.1,0.8-0.2,1.6-0.3,2.4h0.3C169.5,359.6,169.6,358.9,169.7,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx70",
    d: "M169.9,356.9h-0.3c-0.1,0.4-0.1,0.8-0.2,1.1h0.3C169.8,357.7,169.8,357.3,169.9,356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx71",
    d: "M243.8,361.2h-74.5c-0.1,1.1-0.2,2.2-0.3,3.3h64.6c0.1,0,0.1,0,0.2,0C237.6,364.5,241.1,363.3,243.8,361.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx72",
    d: "M247.1,358.1h-4.5c-2.5,1.5-5.4,2.4-8.5,2.4c-0.2,0-0.4,0-0.5,0h-64.1c0,0.3-0.1,0.5-0.1,0.8h74.5 C245,360.3,246.1,359.3,247.1,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx73",
    d: "M247.9,356.9h-3.6c-0.5,0.4-1.1,0.8-1.7,1.1h4.5C247.3,357.7,247.6,357.3,247.9,356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx74",
    d: "M242.6,358.1h-72.9c-0.1,0.8-0.2,1.6-0.3,2.4h64.1c0.2,0,0.4,0,0.5,0C237.2,360.4,240.1,359.6,242.6,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx75",
    d: "M244.2,356.9h-74.3c-0.1,0.4-0.1,0.8-0.2,1.1h72.9C243.2,357.7,243.7,357.3,244.2,356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx53",
    d: "M251.1,354.3h-0.5v0.6C250.8,354.7,251,354.5,251.1,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx76",
    d: "M253.7,174v62.5c1-2.5,2.1-5,3.3-7.5v-46.6C257,179.2,255.7,176.2,253.7,174"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx77",
    d: "M257,229c-1.2,2.4-2.3,4.9-3.3,7.5v51.3c1.1,0,2.2,0.1,3.3,0.2V229"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx78",
    d: "M253.7,287.8v46.1c0,1.4-0.3,2.7-0.7,3.9v2.4c0,2.7-0.9,5.2-2.3,7.3v6.8h0.5c2.3-3,4.3-6.3,5.9-9.7V288 C255.9,287.9,254.8,287.9,253.7,287.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx79",
    d: "M250.7,354.3h-1.1c0,0.1,0,0.3,0,0.4v1.5c0.4-0.4,0.8-0.9,1.1-1.4V354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx80",
    d: "M250.7,347.5c0,0-0.1,0.1-0.1,0.1v0.6c0,1.8-0.4,3.5-0.9,5.1c0,0.3,0,0.6-0.1,1h1.1V347.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx81",
    d: "M249.6,354.3L249.6,354.3l0,0.4C249.5,354.6,249.6,354.4,249.6,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx82",
    d: "M249.6,353.3c0,0.1-0.1,0.2-0.1,0.3v0.7h0C249.6,354,249.6,353.7,249.6,353.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx81",
    d: "M249.5,354.7c-0.1,0.6-0.2,1.3-0.3,1.9c0.1-0.1,0.2-0.3,0.3-0.4V354.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx83",
    d: "M249.5,354.3h-0.3c-0.4,0.9-0.9,1.8-1.4,2.7h1.1c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.6,0.3-1.3,0.3-1.9V354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx84",
    d: "M249.5,353.6c-0.1,0.2-0.2,0.4-0.3,0.7h0.3V353.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx63",
    d: "M169.6,354.3h-0.1c-0.2,0.9-0.3,1.8-0.4,2.7h0.1C169.3,356.1,169.5,355.2,169.6,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx85",
    d: "M170,352.6h-0.1c-0.1,0.6-0.2,1.2-0.3,1.7h0.1C169.8,353.7,169.9,353.1,170,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx86",
    d: "M169.7,354.3L169.7,354.3c-0.2,0.9-0.3,1.8-0.5,2.7h0C169.4,356,169.5,355.2,169.7,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx83",
    d: "M170,354.3h-0.3c-0.2,0.9-0.3,1.8-0.4,2.7h0.3C169.7,356.1,169.8,355.2,170,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx87",
    d: "M170,352.6L170,352.6c-0.2,0.6-0.3,1.2-0.4,1.7h0C169.8,353.7,169.9,353.1,170,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx84",
    d: "M170.3,352.6H170c-0.1,0.6-0.2,1.2-0.3,1.7h0.3C170.1,353.7,170.2,353.1,170.3,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx88",
    d: "M170.2,351.6h-0.1c-0.1,0.3-0.1,0.6-0.2,0.9h0.1C170.1,352.2,170.1,351.9,170.2,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx89",
    d: "M170.2,351.6L170.2,351.6c-0.1,0.3-0.2,0.6-0.2,0.9h0C170.1,352.2,170.2,351.9,170.2,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx90",
    d: "M170.5,351.6h-0.3c-0.1,0.3-0.1,0.6-0.2,0.9h0.3C170.4,352.2,170.5,351.9,170.5,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx91",
    d: "M171.6,346.1h-0.1c-0.5,1.8-1,3.6-1.4,5.5h0.1C170.6,349.8,171.1,347.9,171.6,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx92",
    d: "M171.6,346.1L171.6,346.1c-0.6,1.8-1,3.6-1.5,5.5h0C170.6,349.8,171.1,347.9,171.6,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx93",
    d: "M172,346.1h-0.3c-0.5,1.8-1,3.6-1.4,5.5h0.3c0.3-1.4,0.7-2.9,1.1-4.3C171.7,346.9,171.8,346.5,172,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx94",
    d: "M170.3,354.3H170c-0.2,0.9-0.3,1.8-0.5,2.7h0.3C170,356,170.2,355.2,170.3,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx90",
    d: "M170.4,352.6L170.4,352.6c-0.1,0.6-0.3,1.2-0.4,1.7h0.3c0.1-0.5,0.2-1,0.3-1.5h-0.3 C170.3,352.7,170.3,352.6,170.4,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx93",
    d: "M170.6,351.6L170.6,351.6c-0.1,0.3-0.1,0.6-0.2,0.9h0C170.4,352.2,170.5,351.9,170.6,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx95",
    d: "M171.6,347.3c-0.4,1.4-0.8,2.9-1.1,4.3h0C170.9,350.2,171.2,348.8,171.6,347.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx96",
    d: "M250.6,347.7c-0.2,0.2-0.3,0.4-0.5,0.7c-0.1,0.4-0.2,0.8-0.4,1.2v3.5c0,0.1,0,0.2,0,0.3 c0.6-1.6,0.9-3.3,0.9-5.1V347.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx84",
    d: "M249.6,349.5c0,0.1-0.1,0.2-0.1,0.3v3.8c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3V349.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx97",
    d: "M249.3,354.3h-2.3c-0.8,1-1.7,1.9-2.7,2.7h3.6C248.4,356.1,248.9,355.2,249.3,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx98",
    d: "M249.5,349.8c-0.6,1.6-1.5,3.1-2.6,4.4h2.3c0.1-0.2,0.2-0.4,0.3-0.7V349.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx99",
    d: "M250,348.3c-0.1,0.2-0.3,0.3-0.4,0.4v0.8C249.8,349.1,249.9,348.7,250,348.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx90",
    d: "M249.6,348.8c0,0-0.1,0.1-0.1,0.1v1c0-0.1,0.1-0.2,0.1-0.3V348.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx100",
    d: "M246.9,354.3h-76.6c-0.2,0.9-0.3,1.8-0.4,2.7h74.3C245.2,356.2,246.1,355.3,246.9,354.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx101",
    d: "M249.5,348.9c-2.3,2.4-5.5,3.9-9.1,3.9h-69.8c-0.1,0.5-0.2,1-0.3,1.5h76.6c1.1-1.3,2-2.8,2.6-4.4V348.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx102",
    d: "M253,337.8c-0.5,1.5-1.3,2.8-2.3,4v5.7c1.5-2.1,2.3-4.6,2.3-7.3V337.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx82",
    d: "M250.7,341.8C250.7,341.8,250.6,341.8,250.7,341.8l0,2.3v0.2c0,0.4,0,0.9-0.1,1.3v2c0,0,0.1-0.1,0.1-0.1 V341.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx99",
    d: "M250.6,341.8c0,0-0.1,0.1-0.1,0.1v3.7c0-0.4,0.1-0.9,0.1-1.3v-0.2V341.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx103",
    d: "M172,346.1L172,346.1c-0.1,0.4-0.2,0.8-0.3,1.2C171.7,346.9,171.8,346.5,172,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx104",
    d: "M170.7,352.6h-0.3c0,0.1,0,0.1,0,0.2h0.3C170.6,352.7,170.7,352.6,170.7,352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx103",
    d: "M170.9,351.6h-0.3c-0.1,0.3-0.1,0.6-0.2,0.9h0.3C170.7,352.2,170.8,351.9,170.9,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M172.3,346.1H172c-0.1,0.4-0.2,0.8-0.3,1.2c-0.4,1.4-0.7,2.9-1.1,4.3h0.3 C171.3,349.8,171.8,347.9,172.3,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx106",
    d: "M250.6,345.6c-0.1,0.9-0.3,1.8-0.5,2.7c0.2-0.2,0.4-0.4,0.5-0.7V345.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx90",
    d: "M250.6,341.9c-0.3,0.3-0.6,0.6-0.9,0.9v5.9c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.9,0.4-1.8,0.5-2.7V341.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx101",
    d: "M249.6,342.8c0,0-0.1,0.1-0.1,0.1v5.9c0,0,0.1-0.1,0.1-0.1V342.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx107",
    d: "M249.5,343c-0.7,0.6-1.4,1.1-2.2,1.6c-2.9,4.8-8.1,8-14.1,8c-0.1,0-0.2,0-0.3,0h-62.2c0,0.1,0,0.1,0,0.2 h69.8c3.6,0,6.8-1.5,9.1-3.9V343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx108",
    d: "M247.3,344.5c-0.3,0.2-0.7,0.4-1.1,0.5c-3,4-7.8,6.6-13.2,6.6c0,0-0.1,0-0.1,0h-62c-0.1,0.3-0.1,0.6-0.2,0.9 h62.2c0.1,0,0.2,0,0.3,0C239.2,352.6,244.5,349.3,247.3,344.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx109",
    d: "M246.3,345.1c-1.5,0.7-3.2,1.1-5,1.1h-69c-0.5,1.8-1,3.6-1.4,5.5h62c0,0,0.1,0,0.1,0 C238.4,351.6,243.2,349.1,246.3,345.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx110",
    d: "M253,173.2C253,173.3,253,173.3,253,173.2l0,65.1c0.2-0.6,0.5-1.3,0.7-1.9V174 C253.5,173.7,253.2,173.5,253,173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx111",
    d: "M253.7,236.5c-0.2,0.6-0.5,1.3-0.7,1.9v49.4c0.2,0,0.5,0,0.7,0V236.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx112",
    d: "M253,287.8v50c0.4-1.2,0.7-2.5,0.7-3.9v-46.1C253.5,287.8,253.2,287.8,253,287.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx113",
    d: "M176.7,332.7L176.7,332.7c-2.1,4.3-3.9,8.8-5.3,13.5h0.1c0.4-1.2,0.7-2.4,1.1-3.6c0.8-2.2,1.6-4.3,2.5-6.4 l-0.1,0C175.5,335,176.1,333.8,176.7,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx114",
    d: "M172.6,342.6c-0.4,1.2-0.8,2.4-1.1,3.6h0C171.8,344.9,172.2,343.7,172.6,342.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx114",
    d: "M175.1,336.1L175.1,336.1c-0.9,2.1-1.8,4.2-2.5,6.4C173.4,340.4,174.2,338.2,175.1,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx115",
    d: "M175.3,336.1l-0.2,0c-0.9,2.1-1.8,4.2-2.5,6.4c-0.4,1.2-0.8,2.4-1.1,3.6h0.1 C172.6,342.7,173.9,339.3,175.3,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx116",
    d: "M175.4,336.1L175.4,336.1c-1.5,3.2-2.7,6.6-3.8,10h0C172.7,342.7,173.9,339.3,175.4,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx95",
    d: "M175.6,336.1l-0.3,0c-1.4,3.2-2.7,6.6-3.7,10h0.3C173,342.7,174.2,339.3,175.6,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx117",
    d: "M250,171.2c0.4,1.3,0.6,2.7,0.6,4.2v19.4c0,0.1,0,0.2,0,0.3v50.6c0.7-2.4,1.5-4.8,2.3-7.2v-65.1 c0,0,0-0.1,0-0.1C252.1,172.4,251.1,171.7,250,171.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx118",
    d: "M253,238.4c-0.9,2.4-1.6,4.8-2.3,7.2v42.1c0.8,0,1.6,0,2.3,0.1V238.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx119",
    d: "M250.7,287.7v54.1c1-1.2,1.8-2.5,2.3-4v-50C252.2,287.7,251.4,287.7,250.7,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx41",
    d: "M250.6,194.8v50.9c0,0,0,0,0,0V195C250.7,194.9,250.7,194.9,250.6,194.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx120",
    d: "M250.7,245.6C250.7,245.6,250.6,245.6,250.7,245.6l0,42.1c0,0,0,0,0,0V245.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx99",
    d: "M250.6,287.7v54.1c0,0,0,0,0,0L250.6,287.7C250.7,287.7,250.6,287.7,250.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx40",
    d: "M249.6,171c0,0.1,0,0.2,0,0.3v2.7c0.6,1.6,0.9,3.3,0.9,5.1v14.5c0,0.4,0.1,0.8,0.1,1.1v-19.4 c0-1.5-0.2-2.9-0.6-4.2C249.9,171.1,249.8,171.1,249.6,171"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx42",
    d: "M250.6,193.6V246c0-0.1,0.1-0.2,0.1-0.3v-50.9C250.6,194.4,250.6,194,250.6,193.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx121",
    d: "M250.6,245.6c0,0.1-0.1,0.2-0.1,0.3v41.8c0,0,0.1,0,0.1,0V245.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx122",
    d: "M250.6,287.7v54.2c0,0,0.1-0.1,0.1-0.1L250.6,287.7C250.6,287.7,250.6,287.7,250.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M249.6,171c0,0.1,0,0.2,0,0.3v2.7c0,0,0,0,0,0v-2.7C249.6,171.2,249.6,171.1,249.6,171 C249.6,171,249.6,171,249.6,171"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M249.2,170.8v2.2c0.1,0.3,0.3,0.7,0.4,1v-2.7c0-0.1,0-0.2,0-0.3C249.5,170.9,249.4,170.9,249.2,170.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M249.2,170.8v2.1c0,0,0,0,0,0L249.2,170.8C249.2,170.8,249.2,170.8,249.2,170.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M175.7,336.1L175.7,336.1c-1.5,3.2-2.7,6.6-3.7,10.1h0C173,342.7,174.2,339.3,175.7,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx124",
    d: "M176,336l-0.3,0c-1.5,3.2-2.7,6.6-3.7,10.1h0.3C173.3,342.7,174.6,339.3,176,336"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M249.6,174v15.8c0.4,1.2,0.8,2.5,0.9,3.8v-14.5C250.5,177.3,250.2,175.6,249.6,174"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx44",
    d: "M249.6,189.8v59.7c0.3-1.2,0.6-2.3,0.9-3.5v-52.3C250.4,192.3,250.1,191,249.6,189.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx125",
    d: "M250.6,246c-0.3,1.2-0.6,2.3-0.9,3.5v38.2c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.6,0V246"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx126",
    d: "M249.9,287.7c-0.1,0-0.2,0-0.3,0v47.6l0,0v7.5c0.3-0.3,0.6-0.6,0.9-0.9v-54.2 C250.4,287.7,250.1,287.7,249.9,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx127",
    d: "M249.6,335.3c0,0.1,0,0.3,0,0.4v0.7v0c0,0.5,0,1-0.1,1.6v4.9c0,0,0.1-0.1,0.1-0.1V335.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx108",
    d: "M249.5,338c-0.3,2.4-1,4.6-2.2,6.5c0.8-0.4,1.5-1,2.2-1.6V338"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M249.6,335.7c0,0.4-0.1,0.9-0.1,1.3v1c0.1-0.5,0.1-1,0.1-1.6v0V335.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx109",
    d: "M249.5,337c-0.4,3-1.5,5.8-3.3,8.1c0.4-0.2,0.7-0.3,1.1-0.5c1.2-1.9,1.9-4.2,2.2-6.5V337"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M249.6,174v9c0,0.1,0,0.3,0,0.4v6.3l0,0L249.6,174C249.6,174,249.6,174,249.6,174"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M249.6,183v6.7c0,0,0,0,0,0v-6.3C249.6,183.3,249.6,183.2,249.6,183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx129",
    d: "M249.6,189.7v59.8c0,0,0,0,0-0.1L249.6,189.7C249.6,189.8,249.6,189.8,249.6,189.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx130",
    d: "M249.6,249.5C249.6,249.5,249.6,249.5,249.6,249.5l0,38.2c0,0,0,0,0,0V249.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M249.6,287.7C249.6,287.7,249.6,287.7,249.6,287.7l0,48c0-0.1,0-0.3,0-0.4V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx131",
    d: "M249.2,173v7.1c0.2,1,0.3,1.9,0.4,2.9v-9C249.5,173.6,249.4,173.3,249.2,173"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M249.2,180.1v6.1c0.2,0.8,0.3,1.7,0.3,2.5v0.7c0,0.1,0.1,0.2,0.1,0.3V183C249.6,182,249.5,181,249.2,180.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M249.5,189.5v60.5c0-0.1,0.1-0.3,0.1-0.4v-59.8C249.6,189.7,249.6,189.6,249.5,189.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx134",
    d: "M249.6,249.5c0,0.1-0.1,0.3-0.1,0.4v37.8c0,0,0.1,0,0.1,0V249.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx124",
    d: "M249.6,287.7c0,0-0.1,0-0.1,0V337c0-0.4,0.1-0.8,0.1-1.3V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx131",
    d: "M249.2,173v7.1c0,0,0,0,0,0L249.2,173C249.2,173,249.2,173,249.2,173"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M249.2,180v6.1c0,0,0,0,0,0.1L249.2,180C249.2,180.1,249.2,180.1,249.2,180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx135",
    d: "M249.2,186.2v2.6c0.1,0.2,0.2,0.5,0.3,0.7v-0.7C249.5,187.9,249.4,187,249.2,186.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M249.2,188.8v62.4c0.1-0.4,0.2-0.8,0.3-1.2v-60.5C249.4,189.2,249.3,189,249.2,188.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx137",
    d: "M249.5,249.9c-0.1,0.4-0.2,0.8-0.3,1.2v36.5c0.1,0,0.2,0,0.3,0V249.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx138",
    d: "M249.5,287.7c-0.1,0-0.2,0-0.3,0v23.2c0,0.1,0,0.2,0,0.3v6.3c0,6.8-18.7,12.9-25.5,12.9L176,336 c-1.5,3.3-2.7,6.6-3.7,10.1h69c1.8,0,3.5-0.4,5-1.1c1.7-2.3,2.9-5,3.3-8.1V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx135",
    d: "M249.2,186.1v2.6c0,0,0,0,0,0L249.2,186.1C249.2,186.2,249.2,186.1,249.2,186.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M249.2,188.8v62.5c0,0,0,0,0-0.1L249.2,188.8C249.2,188.8,249.2,188.8,249.2,188.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx137",
    d: "M249.2,251.2C249.2,251.2,249.2,251.2,249.2,251.2l0,36.5c0,0,0,0,0,0V251.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx139",
    d: "M249.2,287.7C249.2,287.7,249.2,287.7,249.2,287.7l0,23.4c0-0.1,0-0.2,0-0.3V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx7",
    d: "M247.1,287.4c-0.7,0-1.4,0-2,0.1c-0.6,0-1.2,0.1-1.8,0.1c-8.6,0.7-16.8,2.6-24.4,5.7c4.5-1.8,9.3-3.2,14.1-4.1 c4.6-1,9.3-1.5,14.1-1.7V287.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx140",
    d: "M245,287.5c-0.6,0-1.2,0.1-1.8,0.1C243.8,287.6,244.4,287.6,245,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx141",
    d: "M247.1,287.5c-4.8,0.2-9.5,0.7-14.1,1.7c0.2,0,0.4-0.1,0.5-0.1c2.7-0.5,5.4-0.9,8.2-1.2 C243.5,287.8,245.3,287.6,247.1,287.5L247.1,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx142",
    d: "M241.7,287.9c-2.8,0.3-5.5,0.7-8.2,1.2c1.4-0.3,2.7-0.5,4.1-0.7c0.6-0.1,1.2-0.2,1.8-0.2 C240.1,288.1,240.9,288,241.7,287.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M239.4,288.2c-0.6,0.1-1.2,0.2-1.8,0.2c0.3,0,0.6-0.1,0.9-0.1C238.8,288.3,239.1,288.3,239.4,288.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx57",
    d: "M247.1,287.6c-1.8,0.1-3.6,0.2-5.4,0.4C243.5,287.8,245.3,287.7,247.1,287.6L247.1,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx58",
    d: "M247.1,287.6L247.1,287.6L247.1,287.6c-1.8,0.1-3.6,0.2-5.4,0.4c-0.8,0.1-1.5,0.2-2.3,0.3 C241.9,287.9,244.5,287.7,247.1,287.6L247.1,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx143",
    d: "M247.1,287.6c-2.6,0.1-5.2,0.3-7.7,0.6c-0.3,0-0.6,0.1-0.8,0.1C241.4,288,244.2,287.8,247.1,287.6 L247.1,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx7",
    d: "M119.4,150c-1,6.5-1.5,12.9-1.5,19.2c0-2,0.1-4,0.2-6v-0.2h0c0-0.2,0-0.4,0-0.6 C118.4,158.2,118.8,154,119.4,150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx144",
    d: "M120.7,143.8h-0.1c-0.4,2.1-0.8,4.1-1.1,6.2c-0.6,4.1-1.1,8.2-1.3,12.4c0.1-2.2,0.3-4.4,0.6-6.6 c0.3-3,0.8-6,1.3-9l0,0C120.3,145.8,120.5,144.8,120.7,143.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx20",
    d: "M235.9,143.8h-0.1H120.7c-0.2,1-0.4,2-0.6,3.1h7.6c0.9-0.6,2.1-0.9,3.2-0.9c0,0,0.1,0,0.1,0h111.8 C240.9,144.6,238.5,143.8,235.9,143.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx18",
    d: "M131,145.9c-1.2,0-2.3,0.3-3.2,0.9h108.9c3.1,0,5.9,1.1,8.1,3h1.9c-0.9-1.5-2.2-2.9-3.7-3.9H131.1 C131,145.9,131,145.9,131,145.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx13",
    d: "M246.6,149.8h-1.9c1.6,1.3,2.8,3,3.6,4.9C248.1,152.9,247.5,151.3,246.6,149.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx24",
    d: "M118.1,162.9L118.1,162.9l0,0.2C118.1,163.1,118.1,163,118.1,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx145",
    d: "M247.5,287.3c-0.1,0-0.3,0-0.4,0v0.1c0.1,0,0.3,0,0.4,0V287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx9",
    d: "M247.5,287.2c-0.1,0-0.3,0-0.4,0.1v0C247.2,287.3,247.4,287.3,247.5,287.2L247.5,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx18",
    d: "M247.5,287.2h-0.3c0,0-0.1,0-0.1,0v0C247.2,287.3,247.4,287.2,247.5,287.2L247.5,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M247.6,287.3c0,0-0.1,0-0.1,0v0.1c0,0,0.1,0,0.1,0V287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx146",
    d: "M247.6,287.2L247.6,287.2c-0.1,0-0.1,0-0.1,0v0.1C247.5,287.3,247.6,287.3,247.6,287.2L247.6,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx147",
    d: "M247.5,287.2L247.5,287.2L247.5,287.2C247.5,287.2,247.5,287.2,247.5,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx148",
    d: "M247.5,287.2c-0.1,0-0.2,0-0.3,0L247.5,287.2L247.5,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx34",
    d: "M247.6,287.2C247.6,287.2,247.6,287.2,247.6,287.2L247.6,287.2L247.6,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx34",
    d: "M247.6,287.2c0,0-0.1,0-0.1,0v0L247.6,287.2C247.6,287.2,247.6,287.2,247.6,287.2L247.6,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx149",
    d: "M118.2,162.4c0,0.2,0,0.4,0,0.6h0C118.2,162.7,118.2,162.6,118.2,162.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx150",
    d: "M118.7,155.8c-0.2,2.2-0.4,4.4-0.6,6.6c0,0.2,0,0.4,0,0.6h0C118.3,160.6,118.5,158.2,118.7,155.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx149",
    d: "M118.1,163.2c-0.1,2-0.2,4-0.2,6c0,5.3,0.4,10.5,1.1,15.6c-0.8-6.2-1.2-12.4-1-18.8c0-0.9,0-1.8,0.1-2.7 V163.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx150",
    d: "M118.1,163.3c0,0.9-0.1,1.8-0.1,2.7c0-0.8,0-1.6,0.1-2.4V163.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx151",
    d: "M118.1,162.9L118.1,162.9c0,0.1,0,0.2,0,0.2v0.2C118.1,163.2,118.1,163.1,118.1,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx152",
    d: "M118.2,162.9L118.2,162.9c0,0.1,0,0.3,0,0.4v0.3C118.1,163.4,118.2,163.2,118.2,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx153",
    d: "M200,281.7c0.8,0.3,1.6,0.5,2.5,0.8c-0.5-0.1-0.9-0.3-1.4-0.4C200.7,282,200.3,281.9,200,281.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx154",
    d: "M201.1,282.1c0.5,0.1,0.9,0.3,1.4,0.4c3.2,1,6.5,1.8,9.9,2.6c7.5,1.6,15.2,2.5,22.9,2.5c0,0,0,0,0,0 c-2.9,0-5.8-0.2-8.7-0.4c-0.9-0.1-1.8-0.2-2.7-0.3c-3.4-0.4-6.8-0.9-10.2-1.6C209.4,284.5,205.2,283.4,201.1,282.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx39",
    d: "M235.2,287.6C235.2,287.6,235.2,287.6,235.2,287.6c0.1,0,0.1,0,0.2,0C235.3,287.6,235.3,287.6,235.2,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx41",
    d: "M213.7,285.3c3.3,0.7,6.7,1.2,10.2,1.6c0.9,0.1,1.8,0.2,2.7,0.3c-3.8-0.3-7.6-0.9-11.4-1.6l-0.1,0 C214.6,285.5,214.1,285.4,213.7,285.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx148",
    d: "M247.2,287.2h-0.1v0C247.1,287.2,247.2,287.2,247.2,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx155",
    d: "M247.5,287.1c-0.1,0-0.3,0-0.4,0.1v0h0.1C247.3,287.2,247.4,287.2,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx156",
    d: "M247.5,287.1c-0.1,0-0.3,0-0.4,0.1v0C247.2,287.2,247.4,287.2,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx157",
    d: "M247.6,287.1c0,0-0.1,0-0.1,0v0C247.5,287.2,247.6,287.2,247.6,287.1L247.6,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx158",
    d: "M247.6,287.1c0,0-0.1,0-0.1,0v0C247.5,287.1,247.6,287.1,247.6,287.1L247.6,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M247.5,287.1c-0.1,0-0.3,0-0.4,0.1v0C247.2,287.2,247.4,287.2,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M247.5,287.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0v0C247.2,287.2,247.4,287.1,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M247.6,287.1c0,0-0.1,0-0.1,0v0C247.5,287.1,247.6,287.1,247.6,287.1L247.6,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M247.6,287.1c0,0-0.1,0-0.1,0v0C247.5,287.1,247.6,287.1,247.6,287.1L247.6,287.1L247.6,287.1L247.6,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M247.2,287.2c-0.1,0-0.1,0-0.2,0v0C247.1,287.2,247.2,287.2,247.2,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx7",
    d: "M218.9,293.3c-18.5,7.2-34,21.1-43.1,39.4l0.6-0.1c4.2-8.4,9.7-15.9,16.3-22.2 C200.1,303.2,209,297.3,218.9,293.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx145",
    d: "M192.6,310.5c-6.6,6.4-12.2,13.9-16.3,22.2l0.1,0c0,0,0,0,0,0C180.6,324.4,186.1,316.9,192.6,310.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M176.4,332.7C176.4,332.7,176.4,332.7,176.4,332.7L176.4,332.7C176.4,332.7,176.4,332.7,176.4,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx142",
    d: "M247.5,287.4c-0.1,0-0.3,0-0.4,0v0.1c0.1,0,0.3,0,0.4,0V287.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx58",
    d: "M247.6,287.4c0,0-0.1,0-0.1,0v0.1c0,0,0.1,0,0.1,0V287.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx85",
    d: "M247.6,287.3C247.6,287.3,247.6,287.3,247.6,287.3l0,0.1l0,0v0.1c0,0,0,0,0,0V287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx161",
    d: "M247.6,287.2L247.6,287.2L247.6,287.2C247.6,287.3,247.6,287.3,247.6,287.2L247.6,287.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx162",
    points: "247.6,287.2 247.6,287.2 247.6,287.2 247.6,287.2 247.6,287.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx163",
    points: "247.6,287.2 247.6,287.2 247.6,287.2 247.6,287.2 247.6,287.2 247.6,287.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M247.5,287.5c-0.1,0-0.3,0-0.4,0v0C247.2,287.5,247.4,287.5,247.5,287.5L247.5,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx143",
    d: "M247.6,287.5c0,0-0.1,0-0.1,0v0C247.5,287.5,247.6,287.5,247.6,287.5L247.6,287.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx87",
    points: "247.6,287.5 247.6,287.5 247.6,287.5 247.6,287.5 247.6,287.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx141",
    d: "M233,289.2c-4.8,1-9.6,2.3-14.1,4.1c-9.8,4-18.7,9.8-26.2,17.1c10.8-10.4,24.5-17.9,39.6-21.1 C232.5,289.3,232.7,289.3,233,289.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx142",
    d: "M232.2,289.4c-15.1,3.2-28.8,10.6-39.6,21.1c-6.6,6.4-12.1,13.9-16.2,22.2c5.2-10.4,12.6-19.5,21.6-26.8 c7.2-5.8,15.4-10.5,24.2-13.6C225.5,291.1,228.8,290.1,232.2,289.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M222.3,292.2c-8.9,3.1-17.1,7.8-24.2,13.6c5-4,10.4-7.5,16.3-10.3C216.9,294.3,219.6,293.2,222.3,292.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx58",
    d: "M198,305.8c-9,7.3-16.4,16.4-21.6,26.8c0,0,0,0,0,0l0.1,0C181.7,322.2,189.1,313.1,198,305.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx143",
    d: "M214.3,295.6c-5.9,2.8-11.3,6.2-16.3,10.3c-8.9,7.3-16.3,16.4-21.6,26.9l0.1,0c0.9-1.8,1.9-3.6,2.9-5.3 c3.5-5.9,7.8-11.3,12.6-16.1C198.6,304.9,206.1,299.5,214.3,295.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx62",
    d: "M179.5,327.4c-1,1.7-2,3.5-2.9,5.3l0,0C177.5,330.9,178.5,329.1,179.5,327.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx164",
    d: "M192.2,311.3c-4.8,4.8-9.1,10.2-12.6,16.1c3.4-5.7,7.5-11,12.2-15.7C191.9,311.6,192,311.4,192.2,311.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx66",
    d: "M191.7,311.7c-4.7,4.7-8.8,10-12.2,15.7c-1,1.7-2,3.5-2.9,5.3l0,0c3.8-7.5,8.7-14.3,14.4-20.3 C191.3,312.2,191.5,311.9,191.7,311.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx68",
    d: "M191.1,312.4c-5.8,5.9-10.6,12.7-14.4,20.3l0,0c2.4-4.8,5.2-9.3,8.5-13.4c1.6-2.1,3.3-4.1,5.1-6 C190.5,313,190.8,312.7,191.1,312.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx165",
    d: "M233.5,289.1c-0.2,0-0.4,0.1-0.5,0.1c-0.2,0-0.5,0.1-0.7,0.2C232.7,289.3,233.1,289.2,233.5,289.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx54",
    d: "M237.6,288.5c-1.4,0.2-2.7,0.4-4.1,0.7c-0.4,0.1-0.8,0.2-1.3,0.3c-3.4,0.7-6.7,1.7-10,2.9 C227.2,290.5,232.3,289.2,237.6,288.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx58",
    d: "M238.5,288.3c-0.3,0-0.6,0.1-0.9,0.1c-5.3,0.8-10.4,2-15.3,3.8c-2.7,1-5.4,2.1-7.9,3.3 c5.7-2.7,11.8-4.8,18.1-6.1C234.5,289,236.5,288.6,238.5,288.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx59",
    d: "M232.5,289.4c-6.3,1.3-12.4,3.4-18.1,6.1c-8.2,4-15.7,9.3-22.2,15.7c0.9-0.9,1.9-1.8,2.8-2.7 c9.4-8.4,20.7-14.7,33.2-18.1C229.6,290.1,231,289.8,232.5,289.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx85",
    d: "M228.2,290.5c-12.5,3.4-23.9,9.7-33.2,18.1c9.1-8.2,20.1-14.3,32.1-17.8C227.5,290.7,227.8,290.6,228.2,290.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx166",
    d: "M195,308.6c-1,0.9-1.9,1.8-2.8,2.7c-0.1,0.1-0.3,0.3-0.4,0.4C192.8,310.6,193.9,309.6,195,308.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx88",
    d: "M227.1,290.8c-12,3.4-23,9.6-32.1,17.8c-1.1,1-2.2,2-3.2,3.1c-0.2,0.2-0.5,0.5-0.7,0.7 C200.9,302.3,213.3,294.8,227.1,290.8C227.1,290.8,227.1,290.8,227.1,290.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx91",
    d: "M227,290.9c-13.8,4-26.2,11.5-36,21.6c-0.3,0.3-0.6,0.6-0.8,0.9c9.8-10.4,22.2-18.1,36-22.2 C226.5,291,226.8,290.9,227,290.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx143",
    d: "M247.5,287.5c-0.1,0-0.3,0-0.4,0v0.1C247.2,287.6,247.4,287.6,247.5,287.5L247.5,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx59",
    d: "M247.5,287.6c-0.1,0-0.3,0-0.4,0v0.1c-2.9,0.1-5.7,0.3-8.5,0.6c-2,0.3-4.1,0.7-6.1,1.1c4.9-1,9.9-1.6,15-1.7 V287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx62",
    d: "M247.6,287.5c0,0-0.1,0-0.1,0v0.1C247.5,287.6,247.6,287.6,247.6,287.5L247.6,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx85",
    d: "M247.6,287.6c0,0-0.1,0-0.1,0v0.1c-5.1,0.1-10.2,0.7-15,1.7c-1.4,0.3-2.8,0.7-4.2,1.1 c5.2-1.4,10.5-2.3,16.1-2.6c1.1-0.1,2.2-0.1,3.3-0.1c0,0,0,0,0,0V287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx167",
    d: "M244.3,287.9c-5.5,0.4-10.9,1.3-16.1,2.6c-0.4,0.1-0.8,0.2-1.2,0.3c0.8-0.2,1.6-0.4,2.4-0.6 c4.2-1.1,8.6-1.8,13.1-2.2C243.1,287.9,243.7,287.9,244.3,287.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx168",
    d: "M229.5,290.2c-0.8,0.2-1.6,0.4-2.4,0.6c0,0,0,0,0,0C227.9,290.6,228.7,290.4,229.5,290.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx168",
    d: "M242.5,288c-4.5,0.4-8.8,1.1-13.1,2.2c4.1-1,8.2-1.8,12.5-2.1C242.2,288,242.3,288,242.5,288"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx169",
    d: "M242,288c-4.3,0.4-8.4,1.1-12.5,2.1c-0.8,0.2-1.6,0.4-2.4,0.7c-0.3,0.1-0.6,0.2-0.9,0.3 C231.3,289.6,236.6,288.6,242,288"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx167",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx170",
    d: "M247.6,287.5C247.6,287.5,247.6,287.5,247.6,287.5l0,0.2l0,0v0c0,0,0,0,0,0V287.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx50",
    points: "247.6,287.1 247.6,287.1 247.6,287.2 247.6,287.2 247.6,287.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx44",
    points: "247.6,287.1 247.6,287.1 247.6,287.1 247.6,287.1 247.6,287.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx133",
    points: "247.6,287.1 247.6,287.1 247.6,287.1 247.6,287.1 247.6,287.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx171",
    d: "M185.1,319.3c-3.2,4.2-6.1,8.6-8.5,13.4l0,0C179.1,327.9,181.9,323.4,185.1,319.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx172",
    d: "M248.3,154.7c0,0.1,0,0.2,0,0.3h0.1C248.4,154.9,248.3,154.8,248.3,154.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx173",
    d: "M248.4,155L248.4,155c0,0.4,0,0.9,0,1.3v4.3h0.7l-0.3,0.2c0.1,0,0.3,0,0.4,0v-1.3 C249.2,157.9,248.9,156.4,248.4,155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx174",
    d: "M249.1,160.6h-0.7v0.4c0.3,0.2,0.6,0.3,0.8,0.5v-0.7c-0.1,0-0.3,0-0.4,0L249.1,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx175",
    d: "M248.4,161v2.5c0.3,0.2,0.6,0.5,0.8,0.7v-2.7C249,161.3,248.7,161.1,248.4,161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx176",
    d: "M119.1,184.8c5.9,43.1,35.2,80.3,76.9,95.6c-14.7-5.4-27.7-13.5-38.8-23.5v0c0,0,0,0,0,0 C136.6,238.2,123,212.7,119.1,184.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx176",
    d: "M157.2,256.8c11.1,10.1,24.1,18.1,38.8,23.5c1.3,0.5,2.6,0.9,4,1.4C183.7,276.4,169.3,267.8,157.2,256.8  M157.2,256.8C157.2,256.8,157.2,256.8,157.2,256.8C157.2,256.8,157.2,256.8,157.2,256.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx177",
    d: "M235.4,287.6c0.4,0,0.9,0,1.3,0c0.2,0,0.3,0,0.5,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0 C236,287.6,235.7,287.6,235.4,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx178",
    d: "M237.2,287.6c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c0.2,0,0.4,0,0.6,0 C237,287.6,237.1,287.6,237.2,287.6c0,0,0.1,0,0.2,0h0c0,0,0,0,0,0C237.4,287.6,237.3,287.6,237.2,287.6 C237.3,287.6,237.3,287.6,237.2,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx179",
    d: "M237.5,287.6c0,0-0.1,0-0.1,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0h0l0,0C237.5,287.6,237.5,287.6,237.5,287.6 L237.5,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M237.8,287.6c-0.1,0-0.2,0-0.3,0h0C237.6,287.6,237.7,287.6,237.8,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx180",
    d: "M237.3,287.6C237.3,287.6,237.3,287.6,237.3,287.6C237.3,287.6,237.3,287.6,237.3,287.6 C237.3,287.6,237.4,287.6,237.3,287.6C237.4,287.6,237.3,287.6,237.3,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M237.5,287.6c0,0-0.1,0-0.1,0c0,0,0,0,0,0C237.4,287.6,237.5,287.6,237.5,287.6 C237.5,287.6,237.5,287.6,237.5,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M246.8,287.2h-0.1c-3,0.4-6.1,0.4-9.2,0.4c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0 C240.9,287.6,243.9,287.6,246.8,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M237.4,287.6c0,0-0.1,0-0.1,0C237.3,287.6,237.4,287.6,237.4,287.6C237.4,287.6,237.5,287.6,237.4,287.6 C237.5,287.6,237.5,287.6,237.4,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M246.7,287.2h-0.4c-2.9,0.4-5.9,0.4-8.9,0.4c0,0,0.1,0,0.1,0C240.6,287.6,243.7,287.6,246.7,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M247.1,287.2c-0.1,0-0.3,0-0.4,0.1h0.1C246.9,287.2,247,287.2,247.1,287.2L247.1,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M247.1,287.1c-0.3,0-0.5,0.1-0.8,0.1h0.4C246.8,287.2,247,287.2,247.1,287.1L247.1,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx157",
    d: "M248.4,163.4v1.9c0.3,0.8,0.6,1.7,0.8,2.6v-3.7C249,163.9,248.7,163.7,248.4,163.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx182",
    d: "M248.4,165.3L248.4,165.3c0.3,0.9,0.6,1.7,0.8,2.6v0C249,167,248.7,166.1,248.4,165.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M248.4,165.3v2c0.3,0.5,0.6,1.1,0.8,1.6v-1C249,167,248.8,166.2,248.4,165.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M248.4,167.4v3.1c0.3,0.1,0.6,0.2,0.8,0.3V169C249,168.4,248.7,167.9,248.4,167.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx183",
    d: "M176.7,332.7L176.7,332.7c-0.7,1.1-1.2,2.3-1.7,3.5l0.1,0C175.6,335,176.2,333.8,176.7,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx184",
    d: "M176.8,332.7L176.8,332.7c-0.6,1.1-1.1,2.3-1.7,3.5l0,0C175.7,335,176.2,333.8,176.8,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx185",
    d: "M176.9,332.6l-0.2,0c-0.6,1.1-1.1,2.3-1.6,3.5l0.2,0C175.8,334.9,176.4,333.8,176.9,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx186",
    d: "M177,332.6L177,332.6c-0.6,1.1-1.2,2.3-1.7,3.5l0.1,0C175.9,334.9,176.4,333.8,177,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M177.3,332.6l-0.3,0c-0.6,1.1-1.1,2.3-1.6,3.5l0.3,0C176.2,334.9,176.7,333.7,177.3,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M248.4,170.5v0.8c0.3,0.5,0.6,1.1,0.8,1.7v-2.1C249,170.7,248.7,170.6,248.4,170.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx187",
    d: "M177.3,332.6L177.3,332.6c-0.6,1.1-1.2,2.3-1.7,3.5l0.1,0C176.2,334.9,176.8,333.7,177.3,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx139",
    d: "M177.7,332.6l-0.3,0c-0.6,1.1-1.1,2.3-1.7,3.5l0.3,0C176.5,334.8,177.1,333.7,177.7,332.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M248.4,171.3v6.1c0.3,0.8,0.6,1.7,0.8,2.6V173C249,172.4,248.7,171.8,248.4,171.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M248.4,177.4v5.9c0.4,0.9,0.6,1.9,0.8,2.8V180C249,179.1,248.7,178.3,248.4,177.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx188",
    d: "M249.2,311.2c-0.1,0.8-0.3,1.5-0.8,2.3v0.9c0,6.8-18.7,12.9-25.5,12.9l-45.3,5.3c-0.6,1.1-1.1,2.3-1.6,3.5 l47.7-5.7c6.8,0,25.5-6,25.5-12.9V311.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M248.4,183.3v3.9c0.3,0.5,0.6,1.1,0.8,1.6v-2.6C249,185.2,248.8,184.2,248.4,183.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M248.4,187.2v68.2c0.2-1.4,0.5-2.7,0.8-4.1v-62.5C249,188.2,248.7,187.7,248.4,187.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx190",
    d: "M249.2,251.2c-0.3,1.4-0.6,2.7-0.8,4.1v32.4c0.3,0,0.5,0,0.8,0V251.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx188",
    d: "M249.2,287.7c-0.3,0-0.5,0-0.8,0v25.7c0.5-0.7,0.8-1.5,0.8-2.3V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx191",
    d: "M120.1,146.8L120.1,146.8c-0.6,3-1,6-1.3,9c0.1-1.1,0.3-2.1,0.4-3.2C119.4,150.7,119.7,148.8,120.1,146.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx13",
    d: "M127.7,146.8h-7.6c-0.4,1.9-0.7,3.8-0.9,5.8c0.1-0.9,0.3-1.8,0.4-2.7h5.4c0.1,0,0.1,0,0.2,0 C125.7,148.6,126.6,147.5,127.7,146.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx192",
    d: "M236.6,146.8H127.7c-1.1,0.7-2,1.8-2.5,3c0.3,0,0.6-0.1,0.9-0.1h118.6C242.5,147.9,239.7,146.8,236.6,146.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx32",
    d: "M125.2,149.9c-0.1,0-0.1,0-0.2,0L125.2,149.9C125.2,149.9,125.2,149.9,125.2,149.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx173",
    d: "M244.7,149.8H126.1c-0.3,0-0.6,0-0.9,0.1c0,0,0,0,0,0h92.2c6.1,0,12.1,1.5,17.5,4.4c0.2,0.2,0.5,0.5,1,0.7 h12.5c0-0.1,0-0.2,0-0.3C247.5,152.8,246.3,151.1,244.7,149.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx174",
    d: "M248.3,155h-12.5c0.3,0.2,0.6,0.3,1,0.5c2,0.5,3.9,1.3,5.6,2.4c1.8,0.8,3.7,1.7,5.4,2.6h0.6v-4.3 C248.4,155.9,248.4,155.4,248.3,155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx175",
    d: "M236.9,155.5L236.9,155.5c2,0.5,3.9,1.3,5.6,2.4c0,0,0,0,0,0C240.8,156.8,238.9,156,236.9,155.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx193",
    d: "M236.9,155.5c1.4,0.7,3.4,1.5,5.6,2.4C240.8,156.8,238.9,156,236.9,155.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx194",
    d: "M248.4,160.6h-0.6c0.2,0.1,0.4,0.2,0.6,0.4V160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx177",
    d: "M119.1,152.6c-0.2,1.1-0.3,2.1-0.4,3.2c-0.3,2.4-0.5,4.8-0.6,7.2h0C118.4,159.5,118.7,156.1,119.1,152.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx195",
    d: "M118.1,166c-0.2,6.3,0.2,12.6,1,18.8c3.9,27.9,17.5,53.4,38.1,72c-10.8-9.9-19.8-21.6-26.3-34.6 c-8.2-16.2-12.8-34.5-12.8-53.9C118,167.6,118,166.8,118.1,166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx177",
    d: "M118.1,163.7c0,0.8-0.1,1.6-0.1,2.4c0,0.8,0,1.5,0,2.3c0,19.4,4.6,37.7,12.8,53.9 c-8.9-17.6-13.4-37.4-12.7-57.8V163.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx196",
    d: "M125,149.9h-5.4c-0.1,0.9-0.3,1.8-0.4,2.7c-0.5,3.5-0.8,6.9-1,10.3h0c0.1-2.6,0.3-5.2,0.6-7.8h1 C120.3,152.4,122.4,150.3,125,149.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx33",
    d: "M125.2,149.9H125c-2.6,0.5-4.7,2.6-5.2,5.2h4.9c0,0,0,0,0,0V152C124.8,151.3,124.9,150.5,125.2,149.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx197",
    d: "M217.3,149.9h-92.2c-0.3,0.7-0.4,1.4-0.4,2.1v3.1c0.4-0.1,0.7-0.1,1.1-0.1h110c-0.5-0.3-0.8-0.5-1-0.7 C229.5,151.4,223.4,149.9,217.3,149.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx198",
    d: "M130.8,222.2c6.6,13,15.5,24.7,26.3,34.6c0,0,0,0,0,0v0c12.1,11,26.5,19.6,42.8,24.9 c0.4,0.1,0.7,0.2,1.1,0.3c-5.8-1.9-11.5-4.2-16.9-6.9c-15.5-7.7-29-18.7-39.7-31.9C139.2,236.8,134.7,229.7,130.8,222.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx196",
    d: "M226.5,287.2c2.9,0.3,5.8,0.4,8.7,0.4c-0.2,0-0.5,0-0.7,0C231.8,287.5,229.2,287.4,226.5,287.2 M184.1,275.2 c5.4,2.7,11.1,5,16.9,6.9c4.1,1.3,8.3,2.4,12.6,3.2C203.2,283.2,193.3,279.8,184.1,275.2 M118.1,164.4 c-0.7,20.4,3.8,40.2,12.7,57.8c3.8,7.5,8.4,14.6,13.6,21.1c-14-17.4-23.2-38.7-25.7-61.8c-0.3-2.9-0.5-5.7-0.6-8.7h0 c0-1.4-0.1-2.8-0.1-4.1c0-1.3,0-2.5,0.1-3.8V164.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx33",
    d: "M234.5,287.6c0.2,0,0.5,0,0.7,0c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0,0.9,0C235.7,287.6,235.1,287.6,234.5,287.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx199",
    d: "M124.8,155.1C124.8,155.1,124.7,155.1,124.8,155.1L124.8,155.1L124.8,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx175",
    d: "M242.4,157.9c1.1,0.8,2.1,1.6,3,2.6h2.3C246.1,159.6,244.2,158.7,242.4,157.9 M235.8,155h-110 c-0.4,0-0.8,0-1.1,0.1v0h108.5c1.2,0,2.5,0.2,3.6,0.4C236.5,155.3,236.1,155.2,235.8,155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx199",
    d: "M118.1,172.8L118.1,172.8c0.1,2.9,0.3,5.8,0.6,8.7C118.5,178.6,118.2,175.7,118.1,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx193",
    d: "M242.4,157.9c1.1,0.8,2.1,1.6,3,2.6h0C244.5,159.6,243.5,158.7,242.4,157.9 C242.4,157.9,242.4,157.9,242.4,157.9 M233.2,155.1H124.8H233.2c1.2,0,2.5,0.2,3.6,0.4l0,0C235.7,155.2,234.5,155.1,233.2,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx178",
    d: "M119.8,155.1h-1c-0.3,2.6-0.5,5.2-0.6,7.8h0.6v-3.8h0.9v-3.1C119.8,155.8,119.8,155.4,119.8,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx200",
    d: "M124.7,155.1h-4.9c-0.1,0.3-0.1,0.7-0.1,1v3.1h0.2C120.7,157.1,122.5,155.5,124.7,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx42",
    d: "M124.8,155.1L124.8,155.1c-2.2,0.4-4,2-4.8,4.1h4.8V155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx179",
    d: "M233.2,155.1H124.8v4.1h108.5h0.5h0.1c0.1,0,0.2,0,0.3,0c2.4,0,4.7,0.5,6.7,1.4h4.6c-0.9-1-1.9-1.9-3-2.6 c-2.1-0.9-4.1-1.7-5.6-2.4C235.7,155.2,234.5,155.1,233.2,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx178",
    d: "M118.1,164.9c0,1.3-0.1,2.5-0.1,3.8c0,1.4,0,2.8,0.1,4.1h0.1c0-1-0.1-2-0.1-3h0c0-0.5,0-1,0-1.5v-1.1V164.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx201",
    d: "M144.5,243.3c10.7,13.2,24.2,24.2,39.7,31.9C168.7,267.5,155.2,256.6,144.5,243.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx178",
    d: "M118.8,181.5c2.5,23,11.7,44.4,25.7,61.8c10.7,13.3,24.3,24.2,39.7,31.9c9.2,4.6,19.1,8,29.5,10.1 c0.4,0.1,0.9,0.2,1.3,0.3l0.1,0c3.8,0.7,7.6,1.2,11.4,1.6c2.7,0.2,5.3,0.4,8,0.4c-3-0.1-5.9-0.3-8.8-0.5 C169.8,281.7,124.9,237.6,118.8,181.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx200",
    d: "M225.7,287.1c2.9,0.3,5.9,0.5,8.8,0.5c0.6,0,1.2,0,1.8,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0,0.4,0C233.4,287.6,229.5,287.4,225.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx179",
    d: "M118.2,172.8L118.2,172.8c0,2.9,0.2,5.8,0.6,8.7c6.2,56.1,51,100.2,106.9,105.6c-5.3-0.5-10.5-1.4-15.6-2.6 c-14.7-3.4-28.4-9.6-40.4-17.9c-14.2-9.8-26.3-22.7-35.1-37.8c-9.4-16-15.2-34.3-16.2-53.9C118.3,174.2,118.2,173.5,118.2,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M210.1,284.5c5.1,1.2,10.3,2.1,15.6,2.6c3.8,0.4,7.6,0.6,11.5,0.6c0,0,0,0,0.1,0 C227.9,287.6,218.8,286.5,210.1,284.5 M134.5,228.7c8.9,15.1,20.9,28,35.1,37.8C155.4,256.7,143.4,243.7,134.5,228.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M119.8,159.2h-0.9v3.8h0v-2.3h0.8c0-0.2,0-0.4,0.1-0.5V159.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M120,159.2h-0.2v0.9C119.8,159.8,119.9,159.5,120,159.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M119.8,160.1c0,0.2-0.1,0.4-0.1,0.5h0.1V160.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M124.8,159.2H120c-0.1,0.3-0.2,0.6-0.2,0.9v0.5h3.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h0.9V159.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M234.1,159.2c-0.1,0-0.2,0-0.3,0h-0.1h-0.5H124.8v1.4h114.6h1.1h0.2l0,0h0.2 C238.8,159.7,236.5,159.2,234.1,159.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M247.5,287.1c-0.1,0-0.2,0-0.3,0C247.3,287.1,247.4,287.1,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M247.6,287.1c0,0-0.1,0-0.1,0v0C247.5,287.1,247.6,287.1,247.6,287.1L247.6,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx199",
    d: "M118.2,162.9L118.2,162.9c0,0.2-0.1,0.5-0.1,0.7v0.7C118.1,163.9,118.2,163.4,118.2,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx199",
    d: "M118.2,162.9L118.2,162.9c0,0.5-0.1,1-0.1,1.5v0.5C118.2,164.2,118.2,163.6,118.2,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx179",
    d: "M118.8,162.9h-0.6c0,0.7-0.1,1.3-0.1,2v2.3h0.1v-3.2c0.2-0.4,0.4-0.7,0.6-1V162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M118.2,167.2h-0.1v1.1c0,0.5,0,1,0,1.5h0.1c0-0.6,0-1.2,0-1.7V167.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M169.7,266.5c12.1,8.3,25.7,14.5,40.4,17.9C195.4,281,181.8,274.9,169.7,266.5 M118.3,174.9 c1.1,19.6,6.8,37.9,16.2,53.9c-7.2-12.3-12.3-26-14.8-40.7v0C119,183.7,118.6,179.3,118.3,174.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M119.8,188L119.8,188c2.5,14.8,7.6,28.5,14.8,40.8c8.8,15,20.9,27.9,35.1,37.8c12.1,8.4,25.8,14.5,40.4,17.9 c8.7,2,17.9,3.1,27.2,3.1c0,0,0.1,0,0.1,0c-19.7,0-38.4-4.8-54.8-13.4c-3.8-2-7.6-4.2-11.2-6.6c-21.2-14.1-37.9-34.9-46.7-60.1v0 C122.6,201.2,120.9,194.7,119.8,188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M124.8,207.5L124.8,207.5c8.8,25.2,25.5,46.1,46.7,60.2c-15.3-10.2-28.2-23.8-37.4-39.9 C130.3,221.3,127.2,214.5,124.8,207.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M182.6,274.2c16.4,8.6,35.1,13.4,54.8,13.4c3,0,6,0,8.9-0.4h-0.3c-2.8,0.3-5.7,0.3-8.5,0.3c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.6,0-1.2,0-1.9,0C216.3,287.1,198.4,282.4,182.6,274.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M235,287.5c0.6,0,1.2,0,1.9,0c0.1,0,0.2,0,0.3,0C236.5,287.5,235.8,287.5,235,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M171.5,267.6c3.6,2.4,7.3,4.6,11.2,6.6c-1.1-0.6-2.2-1.2-3.2-1.8C176.7,271,174,269.3,171.5,267.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M134,227.7c9.2,16.1,22.1,29.8,37.4,39.9c2.6,1.7,5.2,3.3,7.9,4.8c-8.8-4.9-16.9-10.9-24.1-17.8 C147,246.7,139.8,237.7,134,227.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M245.9,287.2h-0.3c-0.2,0-0.5,0-0.7,0.1c-2.5,0.2-5.1,0.2-7.7,0.2c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 C240.3,287.5,243.2,287.5,245.9,287.2 M179.4,272.5c1.1,0.6,2.2,1.2,3.2,1.8c15.8,8.2,33.6,12.9,52.4,13.3 C215.1,287.1,196.1,281.8,179.4,272.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M155.3,254.6c7.2,6.9,15.3,12.9,24.1,17.8c16.7,9.3,35.7,14.6,55.6,15c0.7,0,1.5,0,2.2,0 c2.6,0,5.2,0,7.7-0.2c-2.2,0.1-4.5,0.1-6.8,0.1c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 C205.6,287.4,176.7,275,155.3,254.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M118.9,162.9L118.9,162.9l0,0.1c0,0,0,0,0,0V162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M247.5,287.1c-0.1,0-0.3,0-0.4,0.1v0c0.1,0,0.1,0,0.2,0C247.3,287.1,247.4,287.1,247.5,287.1L247.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M247.1,287.1c-0.4,0.1-0.8,0.1-1.1,0.1h0.3C246.6,287.2,246.8,287.1,247.1,287.1L247.1,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M247.6,287c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0v0l0,0v0.1c0.1,0,0.3,0,0.4-0.1v0 C247.5,287.1,247.6,287.1,247.6,287L247.6,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M247.1,287.1c-0.5,0.1-1,0.1-1.5,0.1h0.3C246.3,287.2,246.7,287.1,247.1,287.1L247.1,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M247.3,287c-0.1,0-0.2,0-0.3,0v0C247.2,287.1,247.3,287,247.3,287 M247.6,287L247.6,287L247.6,287L247.6,287 L247.6,287L247.6,287L247.6,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx156",
    d: "M247.8,160.6h-2.3c0.5,0.5,0.9,1.1,1.3,1.7c0.6,0.3,1.1,0.7,1.6,1.1V161C248.2,160.8,248,160.7,247.8,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx203",
    d: "M245.4,160.6L245.4,160.6c0.5,0.5,0.9,1.1,1.3,1.7c0,0,0,0,0,0C246.4,161.7,245.9,161.1,245.4,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx44",
    d: "M245.4,160.6h-4.6c0,0,0,0,0,0c2.1,0.1,4.2,0.7,5.9,1.7C246.4,161.7,245.9,161.1,245.4,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M123.8,160.6C123.7,160.6,123.7,160.6,123.8,160.6L123.8,160.6C123.8,160.6,123.8,160.6,123.8,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M240.9,160.6h-0.2C240.7,160.6,240.8,160.6,240.9,160.6C240.9,160.6,240.9,160.6,240.9,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M118.8,163.1c-0.2,0.3-0.4,0.6-0.6,1v3.2h0.6V163.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M118.8,167.2h-0.6v0.9c0,0.6,0,1.2,0,1.7h0.6c0-0.7,0-1.4,0-2V167.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M237.6,287.4c-0.1,0-0.1,0-0.2,0c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.5,0C237.9,287.4,237.8,287.4,237.6,287.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M118.9,163C118.8,163,118.8,163.1,118.9,163l0,4.2h0V163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M118.9,167.2L118.9,167.2l0,0.6c0,0.7,0,1.4,0,2h0c0-0.6,0-1.2,0-1.7V167.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M119.7,160.6h-0.8v2.3h0.1c0.2-0.3,0.5-0.5,0.7-0.8v-1C119.7,161,119.7,160.8,119.7,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M119.8,160.6L119.8,160.6c-0.1,0.2-0.1,0.4-0.1,0.6v1c0,0,0.1-0.1,0.1-0.1V160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M123.7,160.6h-3.9v1.5C120.8,161.2,122.2,160.6,123.7,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M118.9,162.9L118.9,162.9l-0.1,0.1C118.9,163,118.9,163,118.9,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx193",
    d: "M246.8,162.3c0.6,0.9,1.2,2,1.6,3v-1.9C247.9,163,247.3,162.6,246.8,162.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx179",
    d: "M246.8,162.3c0.6,0.9,1.2,2,1.6,3v0C248,164.2,247.4,163.2,246.8,162.3C246.8,162.3,246.8,162.3,246.8,162.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx204",
    d: "M240.9,160.6c3.2,1.4,5.8,3.8,7.5,6.8v-2c-0.4-1.1-1-2.1-1.6-3C245,161.3,243,160.7,240.9,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M119.7,162.2c-0.3,0.2-0.5,0.5-0.7,0.8h0.7V162.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx128",
    d: "M119.8,162.1c0,0-0.1,0.1-0.1,0.1v0.8h0.1V162.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M124.8,160.6h-0.9l0,0h-0.2c-1.5,0-2.8,0.6-3.9,1.5v0.9h5V160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M240.7,160.6H124.8v2.3h108.5h0.5c0.1,0,0.2,0,0.3,0c5.7,0,10.8,2.9,13.8,7.4c0.2,0.1,0.4,0.1,0.6,0.2v-3.1 c-1.7-3-4.4-5.4-7.5-6.8C240.8,160.6,240.7,160.6,240.7,160.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M119.7,162.9h-0.7c0,0-0.1,0.1-0.1,0.1v4.2h0.8V162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M119.7,167.2h-0.8v0.9c0,0.6,0,1.2,0,1.7h0.8V167.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx131",
    points: "119.8,162.9 119.7,162.9 119.7,167.2 119.8,167.2 119.8,162.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx132",
    points: "119.8,167.2 119.7,167.2 119.7,169.9 119.8,169.9 119.8,167.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx132",
    points: "124.8,162.9 119.8,162.9 119.8,167.2 124.8,167.2 124.8,162.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M234.1,162.9c-0.1,0-0.2,0-0.3,0h-0.5H124.8v4.3h108.5c3.3,0,6.3,1,8.9,2.7h2.4l0,0h0.4h-0.4 c1.1,0,2.2,0.2,3.3,0.5C244.8,165.9,239.8,162.9,234.1,162.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx133",
    points: "124.8,167.2 119.8,167.2 119.8,169.9 124.8,169.9 124.8,167.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M233.2,167.2H124.8v2.7h117.4C239.5,168.2,236.5,167.2,233.2,167.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M245.6,287.2h-0.2c-0.2,0-0.3,0-0.5,0.1C245.1,287.3,245.4,287.2,245.6,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M245.4,287.2H245c-2.2,0.2-4.6,0.2-7,0.2c0,0,0.1,0,0.1,0c2.3,0,4.6,0,6.8-0.1 C245.1,287.3,245.3,287.2,245.4,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M247.6,287c-0.1,0-0.2,0-0.3,0C247.4,287,247.5,287,247.6,287L247.6,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M247.1,287c-0.5,0.1-1.1,0.2-1.7,0.2h0.2C246.1,287.2,246.6,287.1,247.1,287L247.1,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M247.6,286.9c-0.8,0.1-1.7,0.2-2.6,0.3h0.4c0.6-0.1,1.1-0.1,1.7-0.2v0.1c0.1,0,0.2,0,0.3,0 C247.4,287,247.5,287,247.6,286.9L247.6,286.9L247.6,286.9L247.6,286.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M245,287.2h-2c-1.8,0.1-3.6,0.2-5.4,0.2c0.1,0,0.3,0,0.4,0C240.4,287.4,242.8,287.4,245,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M247.6,286.8c-1.5,0.2-3.1,0.3-4.6,0.4h2c0.9-0.1,1.7-0.2,2.6-0.3V286.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx205",
    d: "M247.7,287.3C247.7,287.3,247.6,287.3,247.7,287.3l-0.1,0.2c0,0,0.1,0,0.1,0V287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx206",
    d: "M247.7,287.2L247.7,287.2L247.7,287.2C247.6,287.3,247.7,287.3,247.7,287.2L247.7,287.2 C247.7,287.3,247.7,287.2,247.7,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx207",
    d: "M247.7,287.2L247.7,287.2C247.7,287.2,247.7,287.3,247.7,287.2L247.7,287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx200",
    d: "M247.7,287.1C247.7,287.2,247.6,287.2,247.7,287.1L247.7,287.1L247.7,287.1 C247.7,287.2,247.7,287.2,247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx208",
    d: "M247.7,287.1C247.7,287.1,247.7,287.1,247.7,287.1C247.7,287.2,247.7,287.2,247.7,287.1L247.7,287.1 L247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx209",
    d: "M247.7,287.5C247.7,287.5,247.6,287.5,247.7,287.5L247.7,287.5C247.6,287.5,247.7,287.5,247.7,287.5 L247.7,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx210",
    d: "M247.7,287.3L247.7,287.3l0,0.2l0,0v0c0,0,0,0,0,0C247.7,287.4,247.7,287.4,247.7,287.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx46",
    points: "247.7,287.3 247.7,287.3 247.7,287.3 247.7,287.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx211",
    d: "M247.8,287.2h-0.1v0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,0,0,0,0.1,0V287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx212",
    d: "M248,287.2h-0.2v0.3c0.1,0,0.1,0,0.2,0V287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx213",
    d: "M247.8,287.1c0,0-0.1,0-0.1,0v0.1L247.8,287.1L247.8,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx214",
    d: "M248,287.1c-0.1,0-0.1,0-0.2,0v0.1h0.2V287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx215",
    d: "M190.2,313.3c-1.8,1.9-3.5,3.9-5.1,6c1.5-1.9,3.1-3.8,4.8-5.6C190,313.5,190.1,313.4,190.2,313.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx113",
    d: "M226.2,291.1c-13.7,4.1-26.2,11.8-36,22.2c-0.1,0.1-0.2,0.3-0.4,0.4c9.7-10.4,22.1-18.2,35.9-22.4 C225.9,291.2,226.1,291.1,226.2,291.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx65",
    d: "M247.6,287.7c-1.1,0-2.2,0.1-3.3,0.1c1-0.1,2.1-0.1,3.1-0.1C247.5,287.7,247.5,287.7,247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx216",
    d: "M247.4,287.7c-1,0-2.1,0.1-3.1,0.1c-0.6,0-1.2,0.1-1.7,0.1C244.1,287.9,245.8,287.8,247.4,287.7 C247.4,287.7,247.4,287.7,247.4,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx91",
    d: "M247.4,287.7c-1.6,0-3.3,0.1-4.9,0.3c-0.2,0-0.4,0-0.6,0.1C243.8,287.9,245.6,287.8,247.4,287.7L247.4,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx115",
    d: "M247.4,287.7c-1.8,0-3.6,0.2-5.4,0.3c-5.4,0.5-10.7,1.5-15.8,3.1c-0.1,0-0.3,0.1-0.4,0.1 c6.6-2,13.6-3.2,20.7-3.5c0.1,0,0.3,0,0.4,0C247.1,287.7,247.3,287.7,247.4,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx116",
    d: "M247,287.7c-0.1,0-0.3,0-0.4,0c0.1,0,0.2,0,0.3,0C246.9,287.7,246.9,287.7,247,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx216",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7c-0.1,0-0.1,0-0.2,0C247.5,287.7,247.5,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx68",
    d: "M247.6,287.7c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0C247.5,287.7,247.5,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx89",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx91",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx217",
    d: "M247.7,287.5C247.7,287.5,247.6,287.5,247.7,287.5l-0.1,0.2l0,0v0c0,0,0.1,0,0.1,0l0,0V287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx91",
    d: "M247.7,287.7C247.7,287.7,247.6,287.7,247.7,287.7L247.7,287.7C247.6,287.7,247.7,287.7,247.7,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx171",
    d: "M247.6,287.7c-0.1,0-0.1,0-0.2,0l0,0C247.5,287.7,247.5,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx115",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx115",
    d: "M247.7,287.7L247.7,287.7C247.7,287.7,247.6,287.7,247.7,287.7L247.7,287.7 C247.6,287.7,247.7,287.7,247.7,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx186",
    d: "M247.6,287.7c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0C247.2,287.7,247.4,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M247.6,287.7c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0C247.1,287.7,247.3,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx219",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M247.7,287.5C247.7,287.5,247.7,287.5,247.7,287.5l0,0.2l0,0l0,0l0,0c0,0-0.1,0-0.1,0v0c0.1,0,0.1,0,0.2,0 C247.8,287.7,247.7,287.6,247.7,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx130",
    d: "M247.8,287.5C247.8,287.5,247.8,287.5,247.8,287.5c-0.1,0.1-0.1,0.1,0,0.2c0,0,0,0,0,0V287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx219",
    d: "M247.8,287.7c-0.1,0-0.1,0-0.2,0v0C247.7,287.7,247.7,287.7,247.8,287.7L247.8,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx213",
    d: "M248,287.5c-0.1,0-0.1,0-0.2,0v0.2c0,0,0,0,0,0l0,0c0.1,0,0.2,0,0.2,0V287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx200",
    d: "M118.1,169.9L118.1,169.9c0,1,0,2,0.1,3h0C118.2,171.8,118.2,170.9,118.1,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx50",
    d: "M118.2,172.8L118.2,172.8c0,0.7,0.1,1.4,0.1,2C118.3,174.2,118.2,173.5,118.2,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M118.2,169.9h-0.1c0,1,0,2,0.1,3h0.1C118.3,171.8,118.3,170.9,118.2,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx46",
    d: "M118.3,172.8h-0.1c0,0.7,0.1,1.4,0.1,2c0.2,4.4,0.7,8.8,1.5,13.1v-0.6c0-0.2-0.1-0.4-0.1-0.7v0 C119,182.1,118.5,177.5,118.3,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M119.8,187.3v0.6c1.1,6.7,2.8,13.2,5,19.5v-0.2C122.6,200.9,120.9,194.2,119.8,187.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M124.8,207.3v0.2c2.5,7.1,5.6,13.9,9.3,20.2C130.3,221.3,127.2,214.4,124.8,207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M119.7,186.6L119.7,186.6c0,0.3,0.1,0.5,0.1,0.7v0C119.7,187.1,119.7,186.9,119.7,186.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M119.8,187.3L119.8,187.3c1.1,6.9,2.8,13.6,5,20v-0.1C122.5,200.7,120.9,194.1,119.8,187.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx131",
    d: "M124.8,207.1v0.1c2.5,7.2,5.6,14,9.3,20.4c5.8,10,12.9,19,21.2,26.9c-8.6-8.2-16-17.7-21.8-28.2 C130,220.3,127.1,213.9,124.8,207.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M133.4,226.5c5.8,10.5,13.2,20,21.8,28.2c21.4,20.3,50.3,32.8,82.1,32.8c0,0,0,0,0,0c0,0,0,0,0,0 C192.8,287.4,153.9,262.8,133.4,226.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx51",
    d: "M118.9,169.9h-0.6c0,1,0,2,0.1,3h0.6C118.9,171.8,118.9,170.9,118.9,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx202",
    d: "M118.9,172.8h-0.6c0.2,4.7,0.6,9.3,1.3,13.8v-0.8c-0.3-2.3-0.6-4.7-0.8-7h0.5c-0.1-1.2-0.2-2.5-0.3-3.7 C119,174.3,119,173.6,118.9,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M119.3,178.8h-0.5c0.2,2.4,0.5,4.7,0.8,7v-3.7C119.5,181,119.4,179.9,119.3,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx160",
    d: "M119.7,185.9v0.8c0,0.2,0.1,0.4,0.1,0.7v-0.8C119.7,186.3,119.7,186.1,119.7,185.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M119.7,182.1v3.7c0,0.2,0.1,0.5,0.1,0.7V183C119.7,182.7,119.7,182.4,119.7,182.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M119.8,186.5v0.8c1.1,6.8,2.8,13.5,5,19.8v-0.2C122.5,200.4,120.8,193.6,119.8,186.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M124.8,206.9v0.2c2.3,6.7,5.2,13.2,8.7,19.3C130,220.3,127.1,213.8,124.8,206.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M119.8,183v3.6c1.1,7,2.8,13.9,5,20.4v-1.6C122.4,198.1,120.7,190.7,119.8,183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M124.8,205.3v1.6c2.3,6.8,5.2,13.3,8.7,19.5c20.4,36.3,59.3,60.9,104,60.9c0.1,0,0.1,0,0.2,0 C184.9,287.2,140.3,252.8,124.8,205.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx131",
    d: "M118.9,169.9L118.9,169.9c0,1,0,2,0.1,3h0C118.9,171.8,118.9,170.9,118.9,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M118.9,172.8L118.9,172.8c0,0.8,0.1,1.5,0.1,2.3C119,174.3,119,173.6,118.9,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx123",
    d: "M247.7,287.1C247.7,287.1,247.6,287.1,247.7,287.1L247.7,287.1C247.6,287.2,247.7,287.2,247.7,287.1 C247.7,287.1,247.7,287.1,247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx220",
    d: "M247.7,287.1C247.7,287.1,247.7,287.1,247.7,287.1C247.7,287.1,247.7,287.1,247.7,287.1 C247.7,287.1,247.7,287.1,247.7,287.1L247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx159",
    d: "M247.7,287.1C247.7,287.1,247.6,287.1,247.7,287.1L247.7,287.1C247.6,287.1,247.7,287.1,247.7,287.1 C247.7,287.1,247.7,287.1,247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx221",
    d: "M247.7,287.1C247.7,287.1,247.7,287.1,247.7,287.1C247.7,287.1,247.7,287.1,247.7,287.1 C247.7,287.1,247.7,287.1,247.7,287.1L247.7,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M247.7,287C247.6,287,247.6,287,247.7,287l-0.1,0.1c0,0,0,0,0,0v0c0,0,0,0,0.1,0 C247.7,287.1,247.7,287,247.7,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx137",
    d: "M247.7,287C247.7,287,247.7,287,247.7,287c0,0,0,0.1,0,0.1c0,0,0,0,0,0v0l0,0V287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx214",
    d: "M248.3,287.2H248v0.3c0.1,0,0.2,0,0.3,0V287.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx222",
    d: "M247.8,287.1c0,0-0.1,0-0.1,0v0C247.7,287.1,247.8,287.1,247.8,287.1L247.8,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx137",
    d: "M248.3,286.9c-0.2,0-0.4,0.1-0.6,0.1v0.1c0,0,0.1,0,0.1,0v0c0.1,0,0.1,0,0.2,0v0.1h0.3v0.3c0,0,0,0,0,0 V286.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx116",
    d: "M189.9,313.7c-1.7,1.8-3.3,3.7-4.8,5.6c-3.2,4.1-6.1,8.6-8.5,13.4l0.1,0 C180.2,325.7,184.7,319.3,189.9,313.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx210",
    d: "M225.8,291.2c-13.8,4.2-26.2,12-35.9,22.4c-5.2,5.6-9.7,12-13.1,19l0,0c0.6-1.2,1.2-2.3,1.8-3.4l0,0 c3.5-6.2,7.7-11.8,12.5-16.7c8.6-8.8,19.1-15.7,30.9-20C223.2,292.1,224.5,291.6,225.8,291.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx186",
    d: "M178.8,329.2l-0.2,0c-0.6,1.1-1.2,2.3-1.8,3.4l0.2,0C177.5,331.5,178.1,330.3,178.8,329.2 M222,292.5 c-11.8,4.2-22.3,11.1-30.9,20c6.2-6.4,13.4-11.7,21.3-15.7c1.5-0.8,3-1.5,4.6-2.2C218.6,293.9,220.3,293.2,222,292.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M178.8,329.2L178.8,329.2c-0.7,1.1-1.3,2.3-1.9,3.5l0.1,0C177.6,331.5,178.2,330.3,178.8,329.2 M216.9,294.6 c-1.5,0.7-3.1,1.4-4.6,2.2c0.9-0.5,1.8-0.9,2.7-1.3C215.7,295.2,216.3,294.9,216.9,294.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M179.1,329.2l-0.2,0c-0.6,1.1-1.3,2.3-1.8,3.4l0.3,0C177.9,331.4,178.5,330.3,179.1,329.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx185",
    d: "M191.1,312.5c-4.8,4.9-9,10.5-12.5,16.7l0,0C182.1,323.1,186.3,317.5,191.1,312.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx186",
    d: "M212.4,296.8c-7.9,4-15.1,9.3-21.3,15.7c-4.8,5-9,10.6-12.5,16.7l0.2,0C186.6,315.4,198.2,304.1,212.4,296.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M215.1,295.5c-0.9,0.4-1.8,0.9-2.7,1.3c-14.1,7.3-25.8,18.6-33.6,32.4l0.1,0c6.4-11.3,15.4-20.9,26.2-28.1 C208.3,299,211.6,297.1,215.1,295.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx105",
    d: "M205.1,301.1c-10.8,7.1-19.8,16.8-26.2,28.1l0.2,0C185.5,317.8,194.4,308.2,205.1,301.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M247.6,286.9C247.6,286.9,247.6,286.9,247.6,286.9L247.6,286.9C247.6,287,247.6,287,247.6,286.9 C247.7,287,247.7,286.9,247.6,286.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx223",
    d: "M247.7,286.9C247.7,286.9,247.7,286.9,247.7,286.9C247.7,286.9,247.7,287,247.7,286.9 C247.7,287,247.7,287,247.7,286.9L247.7,286.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M247.8,170.3c0.2,0.3,0.4,0.6,0.6,1v-0.8C248.2,170.4,248,170.4,247.8,170.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx218",
    d: "M246.5,287.8c-7.1,0.3-14.1,1.5-20.7,3.5c-1.3,0.4-2.6,0.8-3.8,1.3c6.8-2.5,14-4,21.5-4.6 C244.5,287.9,245.5,287.8,246.5,287.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx219",
    d: "M246.9,287.7c-0.1,0-0.2,0-0.3,0c-1,0-2,0.1-3.1,0.2c1-0.1,2-0.1,2.9-0.2 C246.6,287.8,246.7,287.8,246.9,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx219",
    d: "M243.5,287.9c-7.5,0.6-14.7,2.1-21.5,4.6c-1.7,0.6-3.4,1.3-5.1,2.1C225.1,291,234.1,288.7,243.5,287.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx224",
    d: "M246.4,287.8c-1,0-2,0.1-2.9,0.2c-9.4,0.7-18.3,3-26.5,6.7c-0.6,0.3-1.2,0.6-1.9,0.9c3.9-1.8,8-3.4,12.2-4.6 c5.1-1.5,10.5-2.5,16-2.9C244.3,287.9,245.3,287.8,246.4,287.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx109",
    d: "M179.2,329.1L179.2,329.1c-0.7,1.1-1.3,2.3-1.9,3.5l0.1,0C177.9,331.4,178.6,330.3,179.2,329.1 M243.2,288 c-5.5,0.4-10.8,1.4-16,2.9c3.6-1,7.2-1.8,11-2.3C239.9,288.3,241.5,288.1,243.2,288"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx224",
    d: "M227.3,290.9c-4.2,1.2-8.3,2.7-12.2,4.6c-3.5,1.7-6.8,3.6-10,5.7C211.9,296.7,219.3,293.2,227.3,290.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx109",
    d: "M238.2,288.6c-3.7,0.5-7.4,1.3-11,2.3c-8,2.3-15.4,5.8-22.2,10.2c-10.7,7.1-19.6,16.7-26,28l0.1,0 c9.1-16,23.3-28.5,40.4-35.4C225.5,291.3,231.7,289.6,238.2,288.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx139",
    d: "M179.5,329.1l-0.3,0c-0.6,1.1-1.3,2.3-1.8,3.4l0.3,0C178.2,331.4,178.9,330.2,179.5,329.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx139",
    d: "M219.6,293.7c-17.1,6.9-31.3,19.4-40.4,35.4l0.3,0C188.5,313.2,202.6,300.7,219.6,293.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M119.1,175.1c0.1,1.2,0.2,2.5,0.3,3.7h0C119.2,177.6,119.1,176.4,119.1,175.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M119.3,178.8L119.3,178.8c0.1,1.1,0.2,2.2,0.3,3.3V182C119.5,181,119.4,179.9,119.3,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx225",
    d: "M119.7,182L119.7,182c0,0.4,0.1,0.7,0.1,1v-0.1C119.7,182.6,119.7,182.3,119.7,182"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx133",
    d: "M119.8,182.9v0.1c1,7.7,2.6,15.2,5,22.3v-0.2C122.4,198,120.7,190.5,119.8,182.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx135",
    d: "M124.8,205.1v0.2c15.6,47.5,60.2,81.9,112.9,82.1c1.8,0,3.6-0.1,5.4-0.2h-4.9H238 C185.2,287.2,140.4,252.8,124.8,205.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx226",
    d: "M247.6,287.7c-0.2,0-0.5,0-0.7,0c-0.1,0-0.3,0-0.4,0C246.8,287.8,247.2,287.7,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx227",
    d: "M247.6,287.7C247.6,287.7,247.6,287.7,247.6,287.7L247.6,287.7c-0.4,0-0.8,0-1.2,0c-1.1,0.1-2.1,0.1-3.2,0.2 C244.7,287.9,246.1,287.8,247.6,287.7L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx228",
    d: "M247.6,287.7c-1.5,0-2.9,0.1-4.4,0.2c-1.7,0.2-3.4,0.4-5,0.6C241.3,288.2,244.4,287.9,247.6,287.7 L247.6,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx227",
    d: "M247.8,287.7c0,0-0.1,0-0.2,0v0C247.7,287.7,247.7,287.7,247.8,287.7C247.8,287.7,247.8,287.7,247.8,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx222",
    d: "M248.3,287.5c-0.1,0-0.2,0-0.3,0v0.2c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0.2,0,0.4,0,0.5,0V287.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx228",
    d: "M248.3,287.7c-0.2,0-0.4,0-0.5,0c-0.1,0-0.1,0-0.2,0v0.1c-3.2,0.1-6.3,0.3-9.4,0.8c-6.5,1-12.8,2.7-18.7,5.2 C228.5,290.1,238.2,288.1,248.3,287.7L248.3,287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx181",
    d: "M119.7,169.9h-0.8c0,1,0,2,0.1,3h0.7V169.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx133",
    points: "119.8,169.9 119.7,169.9 119.7,172.8 119.8,172.8 119.8,169.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx132",
    d: "M244.5,169.9h-2.4c2.8,1.8,5,4.5,6.3,7.6v-6.1c-0.2-0.3-0.4-0.7-0.6-1C246.8,170,245.7,169.9,244.5,169.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx135",
    points: "124.8,169.9 119.8,169.9 119.8,172.8 124.8,172.8 124.8,169.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M242.1,169.9H124.8v3h108.5c6.9,0.1,12.8,4.4,15.2,10.5v-5.9C247.1,174.3,244.9,171.7,242.1,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx229",
    d: "M248.4,313.4c-3.7,5.8-18.7,10.4-24.7,10.4l-44.3,5.3c-0.6,1.1-1.3,2.3-1.8,3.4l45.3-5.3 c6.8,0,25.5-6.1,25.5-12.9V313.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx135",
    d: "M119.7,172.8h-0.7c0,0.8,0.1,1.5,0.1,2.3c0.1,1.2,0.2,2.5,0.3,3.7h0.3V172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx136",
    d: "M119.7,178.8h-0.3c0.1,1.1,0.2,2.1,0.3,3.2V178.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx136",
    points: "119.8,172.8 119.7,172.8 119.7,178.8 119.8,178.8 119.8,172.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M119.8,178.8h-0.1v3.2c0,0.3,0.1,0.6,0.1,0.9V178.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stx189",
    points: "124.8,172.8 119.8,172.8 119.8,178.8 124.8,178.8 124.8,172.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M233.2,172.8H124.8v6h108.5h0.4c0.1,0,0.2,0,0.3,0c6.1,0,11.5,3.3,14.5,8.3v-3.9 C246,177.2,240.1,172.9,233.2,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M124.8,178.8h-5v4c1,7.7,2.6,15.1,5,22.3V178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx189",
    d: "M234,178.8c-0.1,0-0.2,0-0.3,0h-0.4H124.8v26.3c15.6,47.6,60.4,82,113.3,82.1h0.1h4.9 c1.5-0.1,3.1-0.2,4.6-0.4v0.1c0,0,0,0,0.1,0c-0.6-4.4-0.9-8.8-0.9-13.3c0-6.2,0.6-12.3,1.6-18.2v-68.2 C245.5,182.2,240.1,178.8,234,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx223",
    d: "M248.4,255.3c-1.1,5.9-1.6,12-1.6,18.2c0,4.5,0.3,9,0.9,13.3c0,0,0,0,0,0v0.1c0.2,0,0.4-0.1,0.6-0.1v0.6 c0,0,0,0,0,0v0.2c0,0,0.1,0,0.1,0V255.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx229",
    d: "M248.4,287.7c0,0-0.1,0-0.1,0v0.1c-10.1,0.2-19.8,2.3-28.7,5.9c-17,7-31.1,19.5-40.1,35.4l44.3-5.3 c6,0,21-4.6,24.7-10.4V287.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx230",
    d: "M65.7,149.4h167.5c9.2,0,16.7,7.5,16.7,16.7v0.1v167.7c0.1,9.2-7.4,16.8-16.6,16.8h-0.1H65.7 c-9.3,0-16.8-7.5-16.8-16.8V166.2C48.9,156.9,56.4,149.4,65.7,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stx231",
    d: "M126.5,248.9c-4.1-2.6-7.6-6.1-10.2-10.2c-2.3-4.5-3.5-9.5-3.5-14.6c-0.2-6.9,2.1-13.6,6.5-18.9 c4.7-5.3,10.7-9.2,17.4-11.3c7.6-2.5,15.6-3.7,23.7-3.7c10.5-0.3,21.1,1.1,31.1,4.4v22c-4.3-2.7-9.1-4.6-14.1-5.7 c-5.4-1.3-10.9-2-16.4-2c-5.8-0.2-11.7,1-16.9,3.6c-4,1.8-6.7,5.8-6.7,10.2c0,2.7,1,5.2,2.9,7.1c2.2,2.2,4.8,4.1,7.5,5.5 c3.3,1.5,8.2,3.7,14.5,6.3l2,0.8c6.3,2.4,12.4,5.3,18.2,8.8c9.6,5.5,15.2,16,14.6,27.1c0.3,7-1.9,13.9-6.1,19.6 c-4.2,5.2-9.9,9-16.3,10.9c-7.5,2.4-15.4,3.5-23.2,3.5c-7,0-14.1-0.6-21-1.8c-6-0.9-11.9-2.6-17.5-4.9v-23.2 c5.3,3.7,11.3,6.5,17.5,8.3c6.2,1.9,12.6,3,19.1,3.1c6,0.4,12.1-0.9,17.4-3.7c3.7-2.1,5.9-6,5.9-10.2c0-3-1.2-5.9-3.4-8 c-2.5-2.5-5.4-4.6-8.7-6.2c-3.9-1.9-9.6-4.5-17-7.6C137.7,255.6,131.9,252.5,126.5,248.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepointIcon);
export default __webpack_public_path__ + "static/media/sharepoint-icon.01a6bb2744c4703eb0f3f2d9fd668160.svg";
export { ForwardRef as ReactComponent };